import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      "nav.products": "Products",
      // Navigation
      "nav.home": "Home",
      "nav.categories": "Categories",
      "nav.cart": "Cart",
      "nav.login": "Login",
      "nav.register": "Register",
      "nav.logout": "Logout",
      "nav.dashboard": "Dashboard",
      "nav.language": "Language",
      "nav.discounts": "Discounts",
      "nav.about": "About",

      // Homepage
      "home.hero.title": "Kosher Groceries Delivered to Your Door",
      "home.hero.subtitle": "Order kosher groceries for delivery in Cancun",
      "home.hero.cta": "Start Shopping",
      "home.hero.badge": "Kosher Products Delivered to You",
      "home.hero.secondary": "View Specials",
      "home.hero.secure": "Secure checkout",
      "home.hero.delivery": "Delivery available",
      "home.hero.deliveryStatus": "Delivery Status",
      "home.hero.onTheWay": "On the way!",
      "home.featured": "Featured Products",
      "home.categories": "Shop by Category",
      "home.cta.title": "Ready to start shopping?",
      "home.cta.subtitle":
        "Browse our full catalog and get kosher groceries delivered to your door.",
      "home.cta.button": "Browse All Products",
      "home.discounts.title": "Active Deals",
      "home.discounts.subtitle":
        "Discounts are applied at checkout when eligible",
      "home.trust.quality": "Carefully curated kosher brands",
      "home.trust.qualityDetail": "A focused, curated selection",
      "home.trust.pricing": "Transparent pricing and savings",
      "home.trust.pricingDetail": "Clear prices at checkout",
      "home.trust.support": "Real support when you need it",
      "home.trust.supportDetail": "Call, WhatsApp, or email us",

      // Discounts Page
      "discountsPage.badge": "Special Offers",
      "discountsPage.title": "Products & Categories on Sale",
      "discountsPage.subtitle":
        "Discover amazing deals on your favorite products and categories",
      "discountsPage.loading": "Loading discounts...",
      "discountsPage.noDiscounts": "No Active Discounts",
      "discountsPage.noDiscountsDescription":
        "Check back soon for new deals and special offers on your favorite products",
      "discountsPage.categoriesTitle": "Categories on Sale",
      "discountsPage.categoriesSubtitle":
        "Browse entire categories with special discounts",
      "discountsPage.productsTitle": "Products on Sale",
      "discountsPage.productsSubtitle": "Great deals on individual products",

      // Pagination
      "pagination.previous": "Previous",
      "pagination.next": "Next",
      "pagination.pageOf": "Page {{current}} of {{total}}",

      // Products
      "products.search": "Search products...",
      "products.notFound": "No products found",
      "products.addToCart": "Add to Cart",
      "products.outOfStock": "Out of Stock",
      "products.price": "Price",
      "products.category": "Category",
      "products.all": "All Products",
      "products.allProducts": "All Products",
      "products.allCategories": "All Categories",
      "products.categories": "Categories",
      "products.filters": "Filters",
      "products.viewAll": "View All",
      "products.results": "results",
      "products.noProductsFound": "No products found",
      "products.tryDifferentSearch":
        "Try a different search or browse our categories",
      "products.endOfResults": "You've reached the end of the results",
      "products.loadingMore": "Loading more products...",
      "products.sortByName": "Name (A-Z)",
      "products.priceLowToHigh": "Price: Low to High",
      "products.priceHighToLow": "Price: High to Low",
      "products.featured": "Featured",
      "products.addedToWishlist": "Added to wishlist",
      "products.removedFromWishlist": "Removed from wishlist",

      // Cart
      "cart.title": "Shopping Cart",
      "cart.empty": "Your cart is empty",
      "cart.continueShopping": "Continue Shopping",
      "cart.checkout": "Checkout",
      "cart.total": "Total",
      "cart.quantity": "Quantity",
      "cart.remove": "Remove",
      "cart.update": "Update",
      "cart.clear": "Clear Cart",
      "cart.items": "{{count}} item",
      "cart.items_plural": "{{count}} items",
      "cart.reviewItems": "Review your items and proceed to checkout",
      "cart.trust.secure": "Secure checkout",
      "cart.trust.delivery": "Clear delivery windows",
      "cart.trust.refund": "Hassle-free refunds",

      // Checkout
      "checkout.title": "Checkout",
      "checkout.shipping": "Shipping Information",
      "checkout.payment": "Payment Information",
      "checkout.review": "Review Order",
      "checkout.placeOrder": "Place Order",
      "checkout.firstName": "First Name",
      "checkout.lastName": "Last Name",
      "checkout.email": "Email",
      "checkout.phone": "Phone",
      "checkout.address": "Address",
      "checkout.city": "City",
      "checkout.postalCode": "Postal Code",
      "checkout.guestCheckout": "Continue as Guest",
      "checkout.total": "Total",
      "checkout.productDiscounts": "Product Discounts",
      "checkout.trust.secure": "Secure checkout",
      "checkout.trust.delivery": "Transparent delivery windows",
      "checkout.trust.refund": "Easy refunds policy",

      // Authentication
      "auth.login": "Login",
      "auth.register": "Create Account",
      "auth.welcome": "Welcome to KosherMarket",
      "auth.signInDescription": "Sign in to your account or create a new one",
      "auth.email": "Email Address",
      "auth.password": "Password",
      "auth.confirmPassword": "Confirm Password",
      "auth.firstName": "First Name",
      "auth.lastName": "Last Name",
      "auth.name": "Name",
      "auth.forgotPassword": "Forgot Password?",
      "auth.noAccount": "Don't have an account?",
      "auth.hasAccount": "Already have an account?",

      // Dashboard
      "dashboard.orders": "My Orders",
      "dashboard.profile": "Profile",
      "dashboard.orderHistory": "Order History",
      "dashboard.employee.title": "Employee Dashboard",
      "dashboard.employee.newOrders": "New Orders",
      "dashboard.admin.title": "Admin Dashboard",
      "dashboard.admin.products": "Manage Products",
      "dashboard.admin.categories": "Manage Categories",
      "dashboard.admin.users": "Manage Users",
      "dashboard.admin.discounts": "Manage Discounts",
      "dashboard.admin.analytics": "Analytics",

      // Orders
      "orders.status.pending": "Pending",
      "orders.status.preparing": "Preparing",
      "orders.status.ready": "Ready for Delivery",
      "orders.status.delivered": "Delivered",
      "orders.status.cancelled": "Cancelled",
      "orders.orderNumber": "Order #",
      "orders.date": "Date",
      "orders.status": "Status",
      "orders.total": "Total",
      "orders.updateStatus": "Update Status",
      "orders.statusUpdated": "Order status updated successfully",
      "orders.viewCart": "View Cart",
      "orders.cartContents": "Cart Contents",
      "orders.emptyCart": "No items in this order",
      "orders.cartDetails": "Cart Details",
      "orders.details": "Order Details",

      // Product
      "product.quantity": "Qty",
      "product.each": "each",
      "product.addToCart": "Add to Cart",
      "product.itemsInCart": "{{count}} item in cart",
      "product.itemsInCart_other": "{{count}} items in cart",
      "product.trust.secure": "Secure checkout",
      "product.trust.delivery": "Reliable delivery windows",
      "product.trust.returns": "Easy refunds policy",

      // Common
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.edit": "Edit",
      "common.delete": "Delete",
      "common.add": "Add",
      "common.update": "Update",
      "common.submit": "Submit",
      "common.loading": "Loading...",
      "common.more": "more",
      "common.error": "Error",
      "common.success": "Success",
      "common.required": "Required",
      "common.retry": "Retry",
      "common.back": "Back",
      "common.availableNow": "Available Now",
      "common.page": "Page",
      "common.of": "of",
      "common.showing": "Showing",
      "common.previous": "Previous",
      "common.next": "Next",
      "common.expand": "Expand",
      "common.collapse": "Collapse",
      "common.brand": "Kosher Market",

      // Cookie Consent
      "cookieConsent.title": "Cookie consent",
      "cookieConsent.message":
        "We use cookies for analytics and to improve the site. You can accept or decline.",
      "cookieConsent.accept": "Accept",
      "cookieConsent.decline": "Decline",
      "cookieConsent.learnMore": "Privacy Policy",

      // Error Fallback
      "errorFallback.title": "Something went wrong",
      "errorFallback.description":
        "An unexpected error occurred. Please try again.",
      "errorFallback.details": "Error details",
      "errorFallback.tryAgain": "Try again",

      // Categories
      "categories.fruits": "Fruits & Vegetables",
      "categories.dairy": "Dairy & Eggs",
      "categories.meat": "Meat & Seafood",
      "categories.bakery": "Bakery",
      "categories.pantry": "Pantry Staples",
      "categories.beverages": "Beverages",
      "categories.snacks": "Snacks",
      "categories.household": "Household Items",

      // Sorting and Filtering
      "products.sortBy": "Sort by",
      "products.sortBy.name": "Name A-Z",
      "products.sortBy.priceLow": "Price: Low to High",
      "products.sortBy.priceHigh": "Price: High to Low",
      "products.resultsFound": "products found",
      "products.tryAdjusting": "Try adjusting your search or filter criteria",
      "products.clearFilters": "Clear Filters",
      "products.lowStock": "Low Stock",
      "products.save": "Save",
      "products.inCart": "In Cart",
      "products.inStock": "In Stock",
      "products.stock": "Stock",
      "products.add": "Add",
      "products.name": "Name",
      "products.allLoaded": "All products loaded",
      "products.description": "Description",
      "products.loadError": "Failed to load product",
      "products.backToProducts": "Back to Products",
      "products.off": "off",
      "products.buy": "Buy",
      "products.get": "get",
      "products.free": "free",
      "products.discount": "Discount",
      "products.activeDiscounts": "Active Discounts",
      "products.onlyLeft": "Only {{count}} left",
      "products.onlyLeft_other": "Only {{count}} left",

      // Cart
      "cart.addProducts": "Add some products to get started",
      "cart.subtotal": "Subtotal",
      "cart.tax": "Tax (IVA 16%)",

      // Checkout Steps
      "checkout.enterDelivery": "Enter delivery details",
      "checkout.completePurchase": "Complete your purchase",
      "checkout.backToCart": "Back to Cart",
      "checkout.whereDeliver": "Where should we deliver your groceries?",
      "checkout.continueToPayment": "Continue to Payment",
      "checkout.securelyComplete": "Complete your purchase securely",
      "checkout.demoNotice":
        "This is a demo. Use card number 4242 4242 4242 4242 with any future date and CVV.",
      "checkout.cardholderName": "Cardholder Name",
      "checkout.cardNumber": "Card Number",
      "checkout.expiryDate": "Expiry Date",
      "checkout.cvv": "CVV",
      "checkout.backToShipping": "Back to Shipping",
      "checkout.processing": "Processing...",
      "checkout.orderSummary": "Order Summary",
      "checkout.subtotal": "Subtotal",
      "checkout.taxIVA": "Tax (IVA 16%)",
      "checkout.deliveryAddress": "Delivery Address",
      "checkout.paymentMethod": "Payment Method",
      "checkout.creditCard": "Credit Card",
      "checkout.creditCardDesc": "Pay with your credit or debit card",
      "checkout.cash": "Cash Payment",
      "checkout.cashDesc": "Pay with cash upon delivery",
      "checkout.cashNotice":
        "You will pay with cash when your order is delivered. Please have the exact amount ready.",
      "checkout.placeOrderCash": "Place Order (Cash)",

      // Dashboard
      "dashboard.backToStore": "Back to Store",
      "dashboard.welcomeBack": "Welcome back",
      "dashboard.trackRecent": "Track your recent orders",
      "dashboard.noOrdersYet": "No orders yet",
      "dashboard.startShopping": "Start Shopping",
      "dashboard.customer.title": "Customer Dashboard",
      "dashboard.customer.totalOrders": "Total Orders",
      "dashboard.customer.recentOrders": "Recent Orders",
      "dashboard.customer.orderStats": "Order Statistics",
      "dashboard.customer.pendingOrders": "Pending Orders",
      "dashboard.customer.completedOrders": "Completed Orders",
      "dashboard.customer.filterByStatus": "Filter by Status",
      "dashboard.customer.allStatuses": "All Statuses",
      "dashboard.customer.noOrdersFound": "No orders found",
      "dashboard.customer.viewAllOrders": "View All Orders",
      "dashboard.manageOrders": "Manage orders and inventory",
      "dashboard.manageStore": "Manage your store",
      "dashboard.overview": "Overview",
      "dashboard.totalProducts": "Total Products",
      "dashboard.ordersToday": "Orders Today",
      "dashboard.revenue": "Revenue",
      "dashboard.manageCatalog": "Manage your product catalog",
      "dashboard.addProduct": "Add Product",
      "dashboard.searchProducts": "Search products...",
      "dashboard.product": "Product",
      "dashboard.category": "Category",
      "dashboard.price": "Price",
      "dashboard.stock": "Stock",
      "dashboard.status": "Status",
      "dashboard.actions": "Actions",
      "dashboard.active": "Active",
      "dashboard.inactive": "Inactive",
      "dashboard.organizeCategories": "Organize your product categories",
      "dashboard.addCategory": "Add Category",
      "dashboard.productsCount": "products",
      "dashboard.revenueOverview": "Revenue Overview",
      "dashboard.ordersTrend": "Orders Trend",
      "dashboard.salesByCategory": "Sales by Category",
      "dashboard.customer": "Customer",
      "dashboard.processOrders": "Process customer orders",
      "dashboard.filterByCategory": "Filter by category",
      "dashboard.allCategories": "All Categories",
      "dashboard.noProductsFound": "No products found",
      "dashboard.noProducts": "No products available",
      "dashboard.noCategories": "No categories available",
      "dashboard.slug": "Slug",

      // Admin
      "admin.editProduct": "Edit Product",
      "admin.addProduct": "Add Product",
      "admin.products": "Products",
      "admin.editProductDescription": "Update product information",
      "admin.addProductDescription": "Create a new product",
      "admin.productName": "Product Name",
      "admin.enterProductName": "Enter product name",
      "admin.description": "Description",
      "admin.enterDescription": "Enter product description",
      "admin.price": "Price",
      "admin.stockQuantity": "Stock Quantity",
      "admin.category": "Category",
      "admin.categories": "Categories",
      "admin.noCategories": "No categories available",
      "admin.selectCategory": "Select category",
      "admin.activeProduct": "Active Product",
      "admin.isActive": "Active",
      "admin.imageUrl": "Image URL",
      "admin.productImage": "Product Image",
      "admin.categoryImage": "Category Image",
      "admin.uploadImage": "Upload Image",
      "admin.cropImage": "Crop Image",
      "admin.cropImageDescription":
        "Drag to reposition, use zoom slider to adjust size",
      "admin.zoom": "Zoom",
      "admin.cropInstructions":
        "💡 Drag the image to reposition and use the zoom slider to fit your product",
      "admin.processing": "Processing...",
      "admin.applyCrop": "Apply Crop",
      "admin.dimensions": "Dimensions",
      "admin.originalSize": "Original Size",
      "admin.optimizedSize": "Optimized Size",
      "admin.savings": "Savings",
      "admin.noCategory": "No Category",
      "admin.editCategory": "Edit Category",
      "admin.addCategory": "Add Category",
      "admin.editCategoryDescription": "Update category information",
      "admin.addCategoryDescription": "Create a new category",
      "admin.categoryName": "Category Name",
      "admin.enterCategoryName": "Enter category name",
      "admin.searchCategories": "Search categories...",
      "admin.noSearchResults": "No results found",
      "admin.parentCategory": "Parent Category",
      "admin.noParent": "No Parent",
      "admin.parentCategoryDescription":
        "Select a parent category to create a subcategory (max 2 levels)",
      "admin.subcategoryOf": "Subcategory of",
      "admin.subcategory": "Subcategory",
      "admin.slug": "Slug",
      "admin.slugDescription":
        "URL-friendly identifier (lowercase, hyphens only)",
      "admin.confirmDelete": "Confirm Delete",
      "admin.deleteProductConfirm":
        "Are you sure you want to delete {{name}}? This action cannot be undone.",
      "admin.deleteCategoryConfirm":
        "Are you sure you want to delete {{name}}? This action cannot be undone.",
      "admin.validation.requiredFields": "Please fill in all required fields",
      "admin.validation.slugExists": "This slug already exists",
      "admin.validation.categoryHasProducts":
        "Cannot delete category that contains products",
      "admin.messages.productUpdated": "Product updated successfully",
      "admin.messages.productAdded": "Product added successfully",
      "admin.messages.productDeleted": "Product deleted successfully",
      "admin.messages.categoryUpdated": "Category updated successfully",
      "admin.messages.categoryAdded": "Category added successfully",
      "admin.messages.categoryDeleted": "Category deleted successfully",
      "admin.fillRequiredFields": "Please fill in all required fields",
      "admin.productUpdated": "Product updated successfully",
      "admin.productCreated": "Product created successfully",
      "admin.productDeleted": "Product deleted successfully",

      // Discounts
      "discounts.form.name": "Name",
      "discounts.form.code": "Discount Code",
      "discounts.form.description": "Description",
      "discounts.title": "Discount Management",
      "discounts.subtitle": "Create and manage discount codes and promotions",
      "discounts.addDiscount": "Add Discount",
      "discounts.editDiscount": "Edit Discount",
      "discounts.createNew": "Create New Discount",
      "discounts.updateDetails": "Update the discount details below",
      "discounts.fillDetails": "Fill in the details to create a new discount",
      "discounts.table.code": "Code",
      "discounts.table.automatic": "Automatic",
      "discounts.table.name": "Name",
      "discounts.table.type": "Type",
      "discounts.table.value": "Value",
      "discounts.table.usage": "Usage",
      "discounts.table.status": "Status",
      "discounts.table.dates": "Dates",
      "discounts.table.actions": "Actions",
      "discounts.totalDiscounts": "total discounts",
      "discounts.usageStatistics": "Discount Usage Statistics",
      "discounts.totalUses": "Total Uses",
      "discounts.totalDiscountAmount": "Total Discount Amount",
      "discounts.avgPerUse": "Avg. per Use",
      "discounts.recentUsage": "Recent Usage",
      "discounts.usage.date": "Date",
      "discounts.usage.orderId": "Order ID",
      "discounts.usage.userId": "User ID",
      "discounts.usage.discountAmount": "Discount Amount",
      "discounts.usage.guest": "Guest",
      "discounts.status.active": "Active",
      "discounts.status.inactive": "Inactive",
      "discounts.type.percentage": "Percentage",
      "discounts.type.fixedAmount": "Fixed Amount",
      "discounts.type.buyXGetY": "Buy X Get Y",
      "discounts.type.freeShipping": "Free Shipping",
      "discounts.condition.minimumAmount": "Minimum Amount",
      "discounts.condition.minimumQuantity": "Minimum Quantity",
      "discounts.condition.specificProducts": "Specific Products",
      "discounts.condition.specificCategories": "Specific Categories",
      "discounts.condition.firstOrder": "First Order",
      "discounts.condition.noCondition": "No Condition",
      "discounts.form.discountType": "Discount Type",
      "discounts.form.discountValue": "Discount Value",
      "discounts.form.conditionType": "Condition Type",
      "discounts.form.minimumAmount": "Minimum Amount (MX$)",
      "discounts.form.minimumQuantity": "Minimum Quantity",
      "discounts.form.usageLimit": "Usage Limit",
      "discounts.form.maxDiscountAmount": "Max Discount Amount (MX$)",
      "discounts.form.startDate": "Start Date",
      "discounts.form.endDate": "End Date",
      "discounts.form.active": "Active",
      "discounts.form.priority": "Priority",
      "discounts.form.priorityDescription":
        "Higher priority discounts are applied first (0 = lowest)",
      "discounts.form.applyToSubcategories": "Apply to Subcategories",
      "discounts.form.stackable": "Stackable with other discounts",
      "discounts.form.cancel": "Cancel",
      "discounts.form.create": "Create",
      "discounts.form.update": "Update",
      "discounts.form.discount": "Discount",
      "discounts.form.codePlaceholder": "e.g., SAVE20",
      "discounts.form.unlimitedPlaceholder": "Unlimited",
      "discounts.form.noLimitPlaceholder": "No limit",
      "discounts.form.automaticDiscount": "Automatic Discount",
      "discounts.form.automaticDiscountHelp":
        "Automatic discounts apply based on conditions without requiring a code",
      "discounts.form.required": "*",
      "discounts.select.percentage": "Percentage (%)",
      "discounts.select.fixedAmount": "Fixed Amount (MX$)",
      "discounts.select.buyXGetY": "Buy X Get Y",
      "discounts.select.freeShipping": "Free Shipping",
      "discounts.select.noCondition": "No Condition",
      "discounts.select.minimumAmount": "Minimum Amount",
      "discounts.select.minimumQuantity": "Minimum Quantity",
      "discounts.select.firstOrder": "First Order Only",
      "discounts.form.selectProducts": "Select Products",
      "discounts.form.selectCategories": "Select Categories",
      "discounts.form.productsSelected": "product(s) selected",
      "discounts.form.categoriesSelected": "category(ies) selected",
      "discounts.form.searchProducts": "Search products...",
      "discounts.form.searchCategories": "Search categories...",
      "discounts.form.noProductsFound": "No products found.",
      "discounts.form.noCategoriesFound": "No categories found.",
      "discounts.form.noProductsAvailable":
        "No products available. Please check the API connection.",
      "discounts.form.noCategoriesAvailable":
        "No categories available. Please check the API connection.",

      // Checkout discount messages
      "checkout.discountCode": "Discount Code",
      "checkout.discountCodePlaceholder": "Enter discount code",
      "checkout.discountApply": "Apply",
      "checkout.discountError.enterCode": "Please enter a discount code",
      "checkout.discountError.alreadyApplied":
        "This discount code is already applied",
      "checkout.discountError.invalid": "Invalid discount code",
      "checkout.discountRemove": "Remove",
      "checkout.discountAmount": "Discount",

      // Available Discounts Display
      "discounts.availableCoupons": "Available Coupons",
      "discounts.automaticDiscounts": "Automatic Discounts",
      "discounts.off": "off",
      "discounts.freeShipping": "Free Shipping",
      "discounts.discount": "Discount",
      "discounts.minimumAmount": "Orders over MX${{amount}}",
      "discounts.minimumQuantity": "{{quantity}}+ items required",
      "discounts.firstOrderOnly": "First order only",
      "discounts.noCondition": "No conditions",
      "discounts.validUntil": "Valid until {{date}}",
      "discounts.apply": "Apply",
      "discounts.copyCode": "Copy Code",
      "discounts.applied": "Discount applied!",
      "discounts.codeCopied": "Code copied to clipboard!",
      "discounts.automatic": "Automatic",
      "discounts.automaticApply": "Applied automatically at checkout",
      "discounts.noDiscountsAvailable": "No discounts available at this time",

      // Discount Display Component
      "discounts.availableOffers": "Available Offers",
      "discounts.clickToViewOffers":
        "Click to view available discounts and coupons",
      "discounts.couponCodes": "Coupon Codes",

      // Cart Discount Keys
      "cart.enterCouponCode": "Enter Coupon Code",
      "cart.couponCodePlaceholder": "Enter coupon code",
      "cart.apply": "Apply",
      "cart.applying": "Applying...",
      "cart.appliedDiscounts": "Applied Discounts",
      "discounts.use": "Use",
      "discounts.notEligible": "Not Eligible",

      // Price Example Keys
      "discounts.originalPrice": "Original Price",
      "discounts.yourPrice": "Your Price",
      "discounts.youSave": "You Save",
      "discounts.notApplicableToSample":
        "Minimum MX${price} required for this discount",

      // Cart Specific Keys
      "cart.currentTotal": "Current Total",
      "cart.afterDiscount": "After Discount",
      "discounts.included": "included",

      // Discount Validation Keys
      "discounts.removed": "Discount removed",
      "discounts.noLongerValid": "{{name}} is no longer valid for your cart",
      "discounts.validationError": "Error validating {{name}} discount",

      // Discount Error Messages
      "discounts.errors.inactive": "This discount is currently inactive",
      "discounts.errors.notStarted": "This discount starts on {{date}}",
      "discounts.errors.expired": "This discount expired on {{date}}",
      "discounts.errors.usageLimitReached":
        "This discount has reached its usage limit",
      "discounts.errors.minimumAmountNotMet":
        "Minimum order of MX${{required}} required (current: MX${{current}})",
      "discounts.errors.minimumQuantityNotMet":
        "Minimum {{required}} items required (current: {{current}})",
      "discounts.errors.notFirstOrder":
        "This discount is only valid for first-time customers",

      // Table display
      "discounts.table.productsSelected": "Products: {{count}} selected",
      "discounts.table.categoriesSelected": "Categories: {{count}} selected",
      "discounts.appliesTo.allProducts": "Applies to all products",
      "discounts.table.dateFrom": "From:",
      "discounts.table.dateTo": "To:",

      "admin.categoryUpdated": "Category updated successfully",
      "admin.categoryCreated": "Category created successfully",
      "admin.categoryDeleted": "Category deleted successfully",
      "admin.product": "Product",
      "admin.stock": "Stock",
      "admin.status": "Status",
      "admin.actions": "Actions",

      // Dashboard Missing Keys
      "dashboard.manageProducts": "Manage your product catalog",
      "dashboard.admin.orders": "Manage Orders",
      "dashboard.admin.userUpdated": "User updated successfully",
      "dashboard.admin.userRoleUpdated": "User role updated successfully",
      "dashboard.admin.manageUsers": "Manage user accounts and permissions",
      "dashboard.admin.role": "Role",
      "dashboard.admin.cashPayment": "Cash Payment",
      "dashboard.admin.enabled": "Enabled",
      "dashboard.admin.disabled": "Disabled",
      "dashboard.admin.systemUser": "System User",
      "dashboard.admin.customer": "Customer",
      "dashboard.admin.roles.admin": "Administrator",
      "dashboard.admin.roles.employee": "Employee",
      "dashboard.admin.roles.client": "Client",
      "dashboard.manageAllOrders": "Manage all customer orders",

      // Common Missing Keys
      "common.actions": "Actions",
      "common.name": "Name",

      // Order Success
      "orderSuccess.confirmed": "Order Confirmed!",
      "orderSuccess.thankYou":
        "Thank you for your purchase. Your order has been successfully placed.",
      "orderSuccess.orderNumber": "Order Number",
      "orderSuccess.estimatedDelivery": "Estimated Delivery",
      "orderSuccess.businessDays": "2-3 business days",
      "orderSuccess.whatNext": "What happens next?",
      "orderSuccess.orderConfirmation": "Order Confirmation",
      "orderSuccess.emailConfirmation":
        "You'll receive an email confirmation shortly",
      "orderSuccess.orderPreparation": "Order Preparation",
      "orderSuccess.teamPrepare": "Our team will prepare your fresh groceries",
      "orderSuccess.delivery": "Delivery",
      "orderSuccess.orderDelivered":
        "Your order will be delivered to your address",
      "orderSuccess.viewOrderDetails": "View Order Details",
      "orderSuccess.continueShopping": "Continue Shopping",
      "orderSuccess.needHelp": "Need help with your order?",
      "orderSuccess.contactSupport": "Contact Support",

      // Authentication Guest
      "auth.continueGuest": "Continue as Guest",
      "auth.continueWithGoogle": "Continue with Google",
      "auth.orEmail": "or sign in with email",

      // Profile
      "profile.name": "Name",
      "profile.email": "Email",
      "profile.role": "Role",
      "profile.manageAccount": "Manage your account information",

      // Toast Messages
      "toast.loginSuccess": "Login successful!",
      "toast.loginError": "Invalid email or password",
      "toast.loginErrorGeneral": "An error occurred during login",
      "toast.passwordsNotMatch": "Passwords do not match",
      "toast.passwordTooShort": "Password must be at least 6 characters",
      "toast.accountCreated": "Account created successfully!",
      "toast.accountCreateFailed": "Failed to create account",
      "toast.registrationError": "An error occurred during registration",
      "toast.pleaseLogin": "Please login to add items to cart",
      "toast.notEnoughStock": "Not enough stock available",
      "toast.addedToCart": "added to cart",
      "toast.removedFromCart": "Item removed from cart",
      "toast.cartCleared": "Cart cleared",
      "toast.failedToAddToCart": "Failed to add item to cart",
      "toast.failedToRemoveFromCart": "Failed to remove item from cart",
      "toast.failedToUpdateCart": "Failed to update cart",
      "toast.fillRequiredFields": "Please fill in all required fields",
      "toast.orderPlaced": "Order placed successfully!",
      "toast.orderPlacedCash":
        "Order placed successfully! Please have cash ready for delivery.",
      "toast.paymentFailed": "Payment failed. Please try again.",
      "toast.creatingAccount": "Creating account...",

      "toast.discountsFetchFailed": "Failed to fetch discounts",
      "toast.discountUpdated": "Discount updated",
      "toast.discountCreated": "Discount created",
      "toast.discountSaveFailed": "Failed to save discount",
      "toast.discountDeleted": "Discount deleted",
      "toast.discountDeleteFailed": "Failed to delete discount",
      "toast.discountUsageFetchFailed": "Failed to fetch discount usage",

      // Footer
      "footer.company.title": "Kosher Market",
      "footer.company.description":
        "Your trusted source for quality kosher products delivered fresh to your door.",
      "footer.tagline": "Premium kosher groceries delivered with care.",
      "footer.quickLinks.title": "Quick Links",
      "footer.quickLinks.home": "Home",
      "footer.quickLinks.products": "Products",
      "footer.quickLinks.about": "About Us",
      "footer.quickLinks.account": "My Account",
      "footer.legal.title": "Legal",
      "footer.legal.privacy": "Privacy Policy",
      "footer.legal.terms": "Terms & Conditions",
      "footer.legal.refund": "Refund Policy",
      "footer.contact.title": "Contact Us",
      "footer.contact.addressLine": "Cancún, Quintana Roo, México",
      "footer.copyright": "Kosher Market. All rights reserved.",
      "footer.developedBy": "Developed by",
      "footer.followUs": "Follow Us",
      "footer.trust.certified": "Certified Kosher",
      "footer.trust.supervised": "Rabbinical supervision",
      "footer.trust.delivery": "Reliable Delivery",
      "footer.trust.windows": "Clear delivery windows",
      "footer.trust.secure": "Secure Payments",
      "footer.trust.protected": "Encrypted checkout",

      // Header
      "header.tagline": "Premium kosher groceries",
      "header.trust.certified": "Kosher products only",
      "header.trust.delivery": "Same-day delivery in Cancun",
      "header.trust.secure": "Secure checkout",

      // About Page
      "about.title": "About Us",
      "about.subtitle": "Your trusted partner for kosher products",
      "about.story.title": "Our Story",
      "about.story.paragraph1":
        "Kosher Market was founded with a simple mission: to make high-quality kosher products accessible to everyone in our community. What started as a small local operation has grown into a comprehensive online marketplace serving families across the region.",
      "about.story.paragraph2":
        "We understand the importance of maintaining kashrut standards while also meeting modern consumer needs. That's why we carefully curate our selection to include only certified kosher products from trusted suppliers and manufacturers.",
      "about.story.paragraph3":
        "Our team is dedicated to providing exceptional customer service, competitive prices, and convenient delivery options. Whether you're preparing for Shabbat, a holiday, or everyday meals, we're here to serve you.",
      "about.mission.title": "Our Mission",
      "about.mission.description":
        "To provide our community with convenient access to the highest quality kosher products, delivered with care and attention to detail. We strive to make kosher shopping easy, affordable, and reliable for every household.",
      "about.whyChooseUs": "Why Choose Us?",
      "about.features.quality.title": "Premium Quality",
      "about.features.quality.description":
        "We source only the finest kosher products from certified suppliers.",
      "about.features.kosher.title": "100% Kosher Certified",
      "about.features.kosher.description":
        "All our products meet strict kosher certification standards.",
      "about.features.delivery.title": "Fast Delivery",
      "about.features.delivery.description":
        "Quick and reliable delivery right to your doorstep.",
      "about.features.secure.title": "Secure Shopping",
      "about.features.secure.description":
        "Your payment information is always protected and secure.",
      "about.features.support.title": "Customer Support",
      "about.features.support.description":
        "Our friendly team is here to help you with any questions.",
      "about.features.certified.title": "Certified Products",
      "about.features.certified.description":
        "Every product is verified and certified by recognized authorities.",
      "about.cta.title": "Have Questions?",
      "about.cta.description":
        "Our team is here to help. Contact us anytime for assistance.",
      "about.cta.contact": "Call Us",
      "about.cta.whatsapp": "WhatsApp",

      // Privacy Policy
      "privacy.title": "Privacy Policy",
      "privacy.lastUpdated": "Last Updated",
      "privacy.introduction":
        "At Kosher Market, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our website and services.",
      "privacy.informationCollected.title": "Information We Collect",
      "privacy.informationCollected.content":
        "We collect information that you provide directly to us, including:\n\n• Personal details (name, email, phone number)\n• Delivery address and contact information\n• Payment information (processed securely through our payment partners)\n• Order history and preferences\n• Communication preferences\n\nWe also automatically collect certain information about your device and how you interact with our website, including IP address, browser type, and usage patterns.",
      "privacy.howWeUse.title": "How We Use Your Information",
      "privacy.howWeUse.content":
        "We use the information we collect to:\n\n• Process and fulfill your orders\n• Communicate with you about your orders and account\n• Provide customer support\n• Improve our products and services\n• Send you promotional communications (with your consent)\n• Prevent fraud and enhance security\n• Comply with legal obligations\n\nWe never sell your personal information to third parties.",
      "privacy.dataProtection.title": "Data Protection & Security",
      "privacy.dataProtection.content":
        "We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, or misuse. This includes:\n\n• Encrypted data transmission (SSL/TLS)\n• Secure payment processing\n• Regular security audits\n• Access controls and authentication\n• Employee training on data protection\n\nWhile we strive to protect your information, no method of transmission over the internet is 100% secure.",
      "privacy.cookies.title": "Cookies & Tracking",
      "privacy.cookies.content":
        "We use cookies and similar technologies to:\n\n• Remember your preferences and settings\n• Understand how you use our website\n• Improve your browsing experience\n• Provide personalized content\n\nYou can control cookies through your browser settings. However, disabling cookies may affect your ability to use certain features of our website.",
      "privacy.yourRights.title": "Your Rights",
      "privacy.yourRights.content":
        "You have the right to:\n\n• Access your personal information\n• Correct inaccurate data\n• Request deletion of your data\n• Object to processing of your data\n• Withdraw consent at any time\n• Export your data\n\nTo exercise these rights, please contact us using the information below.",
      "privacy.contact.title": "Changes to This Policy",
      "privacy.contact.content":
        "We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new policy on our website and updating the 'Last Updated' date.\n\nYour continued use of our services after any changes indicates your acceptance of the updated policy.",
      "privacy.questions": "Questions About Privacy?",
      "privacy.contactUs":
        "If you have any questions or concerns about this Privacy Policy or our data practices, please contact us:",
      "privacy.emailUs": "Email Us",
      "privacy.callUs": "Call Us",

      // Privacy sections (alternative keys for compatibility)
      "privacy.section1.title": "Information We Collect",
      "privacy.section1.text":
        "We collect information that you provide directly to us, including:\n\n• Personal details (name, email, phone number)\n• Delivery address and contact information\n• Payment information (processed securely through our payment partners)\n• Order history and preferences\n• Communication preferences\n\nWe also automatically collect certain information about your device and how you interact with our website, including IP address, browser type, and usage patterns.",
      "privacy.section2.title": "How We Use Your Information",
      "privacy.section2.text":
        "We use the information we collect to:\n\n• Process and fulfill your orders\n• Communicate with you about your orders and account\n• Provide customer support\n• Improve our products and services\n• Send you promotional communications (with your consent)\n• Prevent fraud and enhance security\n• Comply with legal obligations\n\nWe never sell your personal information to third parties.",
      "privacy.section3.title": "Data Protection & Security",
      "privacy.section3.text":
        "We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, or misuse. This includes:\n\n• Encrypted data transmission (SSL/TLS)\n• Secure payment processing\n• Regular security audits\n• Access controls and authentication\n• Employee training on data protection\n\nWhile we strive to protect your information, no method of transmission over the internet is 100% secure.",
      "privacy.section4.title": "Cookies & Tracking",
      "privacy.section4.text":
        "We use cookies and similar technologies to:\n\n• Remember your preferences and settings\n• Understand how you use our website\n• Improve your browsing experience\n• Provide personalized content\n\nYou can control cookies through your browser settings. However, disabling cookies may affect your ability to use certain features of our website.",
      "privacy.section5.title": "Your Rights",
      "privacy.section5.text":
        "You have the right to:\n\n• Access your personal information\n• Correct inaccurate data\n• Request deletion of your data\n• Object to processing of your data\n• Withdraw consent at any time\n• Export your data\n\nTo exercise these rights, please contact us using the information below.",
      "privacy.section6.title": "Changes to This Policy",
      "privacy.section6.text":
        "We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new policy on our website and updating the 'Last Updated' date.\n\nYour continued use of our services after any changes indicates your acceptance of the updated policy.",

      // Terms & Conditions
      "terms.title": "Terms & Conditions",
      "terms.lastUpdated": "Last Updated",
      "terms.introduction":
        "Welcome to Kosher Market. By accessing and using our website and services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.",
      "terms.section1.title": "Acceptance of Terms",
      "terms.section1.text":
        "By using Kosher Market's website and services, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions. If you do not agree with any part of these terms, please do not use our services.\n\nWe reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the modified terms.",
      "terms.section2.title": "Orders and Payments",
      "terms.section2.text":
        "• All orders are subject to product availability and acceptance by Kosher Market\n• Prices are in Mexican Pesos (MXN) and subject to change without notice\n• Payment must be completed at the time of order placement\n• We accept major credit cards and cash on delivery\n• You agree to provide accurate payment and delivery information\n• Order confirmation will be sent via email upon successful payment",
      "terms.section3.title": "Delivery Terms",
      "terms.section3.text":
        "• Delivery times are estimates and not guaranteed\n• We deliver to specified addresses within our service area\n• Someone must be present to receive the delivery\n• We are not responsible for delays caused by circumstances beyond our control\n• Delivery fees may apply based on location and order value\n• Special delivery instructions should be provided at checkout",
      "terms.section4.title": "Product Information",
      "terms.section4.text":
        "• We strive to provide accurate product descriptions and images\n• All products are certified kosher by recognized authorities\n• Actual product packaging may vary from images shown\n• We reserve the right to substitute products of equal or greater value if items are unavailable\n• Kosher certifications are verified at the time of listing but may change",
      "terms.section5.title": "User Responsibilities",
      "terms.section5.text":
        "• You must be at least 18 years old to use our services\n• You are responsible for maintaining account confidentiality\n• You agree not to use our services for unlawful purposes\n• You must provide accurate and complete information\n• You agree to notify us of any unauthorized account use\n• Multiple accounts by the same user are not permitted",
      "terms.section6.title": "Limitation of Liability",
      "terms.section6.text":
        "Kosher Market shall not be liable for:\n• Indirect, incidental, or consequential damages\n• Loss of profits or business opportunities\n• Delays in delivery due to circumstances beyond our control\n• Product quality issues covered by our refund policy\n• Third-party service failures\n\nOur total liability is limited to the value of your order.",
      "terms.questions": "Questions About These Terms?",
      "terms.contactUs":
        "If you have any questions about these Terms & Conditions, please contact us:",
      "terms.emailUs": "Email Us",
      "terms.callUs": "Call Us",

      // Refund Policy
      "refund.title": "Refund Policy",
      "refund.lastUpdated": "Last Updated",
      "refund.introduction":
        "At Kosher Market, we want you to be completely satisfied with your purchase. This Refund Policy outlines our guidelines for returns, refunds, and exchanges.",
      "refund.section1.title": "General Refund Policy",
      "refund.section1.text":
        "We offer refunds or replacements for products that:\n• Arrive damaged or defective\n• Are significantly different from description\n• Are past their expiration date upon delivery\n• Are missing from your order\n\nRefunds are processed to the original payment method within 5-7 business days after approval. For cash payments, refunds are issued as store credit.",
      "refund.section2.title": "Eligibility for Refunds",
      "refund.section2.text":
        "To be eligible for a refund, you must:\n• Contact us within 24 hours of delivery\n• Provide photos of damaged or defective products\n• Have the product in its original packaging (when possible)\n• Provide your order number and contact information\n\nNote: Perishable items cannot be returned for hygiene and safety reasons, but may qualify for replacement if defective.",
      "refund.section3.title": "Refund Process Timeline",
      "refund.section3.text":
        "1. Contact Us: Reach out within 24 hours of delivery\n2. Review: Our team reviews your request within 1-2 business days\n3. Approval: Approved refunds are processed within 24 hours\n4. Refund: Money returns to your account in 5-7 business days\n\nFor urgent issues, please call us directly at +52 998 550 5030.",
      "refund.section4.title": "Non-Refundable Items",
      "refund.section4.text":
        "The following items are not eligible for refund:\n• Products opened or consumed\n• Special order or custom items\n• Gift cards and promotional items\n• Products damaged due to misuse\n• Items not reported within 24 hours\n• Products returned without prior authorization",
      "refund.section5.title": "Refund Methods",
      "refund.section5.text":
        "Refunds are issued based on your original payment method:\n\n• Credit/Debit Card: Refunded to the same card within 5-7 business days\n• Cash Payment: Issued as store credit for future purchases\n• Bank Transfer: Requires your banking details, processed within 5-7 business days\n\nStore credit never expires and can be used for any future purchase.",
      "refund.section6.title": "Exchanges and Replacements",
      "refund.section6.text":
        "We offer free replacements for:\n• Damaged products received\n• Incorrect items delivered\n• Products with quality issues\n\nReplacements are shipped at no additional cost. If the product is unavailable, we offer a full refund or store credit. Contact us to arrange a replacement.",
      "refund.questions": "Questions About Refunds?",
      "refund.contactUs":
        "If you have any questions about our Refund Policy or need to request a refund, please contact us:",
      "refund.emailUs": "Email Us",
      "refund.callUs": "Call Us",
    },
  },
  es: {
    translation: {
      "nav.products": "Productos",
      // Navigation
      "nav.home": "Inicio",
      "nav.categories": "Categorías",
      "nav.cart": "Carrito",
      "nav.login": "Iniciar Sesión",
      "nav.register": "Registrarse",
      "nav.logout": "Cerrar Sesión",
      "nav.dashboard": "Panel",
      "nav.language": "Idioma",
      "nav.discounts": "Descuentos",
      "nav.about": "Acerca de",

      // Homepage
      "home.hero.title": "Productos Kosher Entregados a su Puerta",
      "home.hero.subtitle": "Pida productos kosher con entrega en Cancún",
      "home.hero.cta": "Comenzar a Comprar",
      "home.hero.badge": "Productos Kosher a tu Puerta",
      "home.hero.secondary": "Ver Especiales",
      "home.hero.secure": "Pago seguro",
      "home.hero.delivery": "Entrega disponible",
      "home.hero.deliveryStatus": "Estado del Envío",
      "home.hero.onTheWay": "¡En camino!",
      "home.featured": "Productos Destacados",
      "home.categories": "Comprar por Categoría",
      "home.cta.title": "¿Listo para comenzar a comprar?",
      "home.cta.subtitle":
        "Explora nuestro catálogo completo y recibe productos kosher en tu puerta.",
      "home.cta.button": "Ver Todos los Productos",
      "home.discounts.title": "Ofertas Activas",
      "home.discounts.subtitle":
        "Los descuentos se aplican al pagar cuando corresponda",
      "home.trust.quality": "Marcas kosher cuidadosamente seleccionadas",
      "home.trust.qualityDetail": "Una selección cuidada y enfocada",
      "home.trust.pricing": "Precios y ahorros transparentes",
      "home.trust.pricingDetail": "Precios claros al pagar",
      "home.trust.support": "Soporte real cuando lo necesitas",
      "home.trust.supportDetail": "Llámanos, WhatsApp o correo",

      // Discounts Page
      "discountsPage.badge": "Ofertas Especiales",
      "discountsPage.title": "Productos y Categorías en Oferta",
      "discountsPage.subtitle":
        "Descubre increíbles ofertas en tus productos y categorías favoritas",
      "discountsPage.loading": "Cargando descuentos...",
      "discountsPage.noDiscounts": "Sin Descuentos Activos",
      "discountsPage.noDiscountsDescription":
        "Vuelve pronto para nuevas ofertas y promociones especiales en tus productos favoritos",
      "discountsPage.categoriesTitle": "Categorías en Oferta",
      "discountsPage.categoriesSubtitle":
        "Explora categorías completas con descuentos especiales",
      "discountsPage.productsTitle": "Productos en Oferta",
      "discountsPage.productsSubtitle":
        "Grandes ofertas en productos individuales",

      // Pagination
      "pagination.previous": "Anterior",
      "pagination.next": "Siguiente",
      "pagination.pageOf": "Página {{current}} de {{total}}",

      // Products
      "products.search": "Buscar productos...",
      "products.notFound": "No se encontraron productos",
      "products.addToCart": "Agregar al Carrito",
      "products.outOfStock": "Agotado",
      "products.price": "Precio",
      "products.category": "Categoría",
      "products.all": "Todos los Productos",
      "products.allProducts": "Todos los Productos",
      "products.allCategories": "Todas las Categorías",
      "products.categories": "Categorías",
      "products.filters": "Filtros",
      "products.viewAll": "Ver Todo",
      "products.results": "resultados",
      "products.noProductsFound": "No se encontraron productos",
      "products.tryDifferentSearch":
        "Intenta una búsqueda diferente o navega por nuestras categorías",
      "products.endOfResults": "Has llegado al final de los resultados",
      "products.loadingMore": "Cargando más productos...",
      "products.sortByName": "Nombre (A-Z)",
      "products.priceLowToHigh": "Precio: Menor a Mayor",
      "products.priceHighToLow": "Precio: Mayor a Menor",
      "products.featured": "Destacado",
      "products.addedToWishlist": "Añadido a favoritos",
      "products.removedFromWishlist": "Eliminado de favoritos",

      // Cart
      "cart.title": "Carrito de Compras",
      "cart.empty": "Su carrito está vacío",
      "cart.continueShopping": "Continuar Comprando",
      "cart.checkout": "Finalizar Compra",
      "cart.total": "Total",
      "cart.quantity": "Cantidad",
      "cart.remove": "Eliminar",
      "cart.update": "Actualizar",
      "cart.clear": "Vaciar Carrito",
      "cart.items": "{{count}} artículo",
      "cart.items_plural": "{{count}} artículos",
      "cart.reviewItems": "Revisa tus artículos y procede al pago",
      "cart.trust.secure": "Pago seguro",
      "cart.trust.delivery": "Ventanas de entrega claras",
      "cart.trust.refund": "Reembolsos sin complicaciones",

      // Checkout
      "checkout.title": "Finalizar Compra",
      "checkout.shipping": "Información de Envío",
      "checkout.payment": "Información de Pago",
      "checkout.review": "Revisar Pedido",
      "checkout.placeOrder": "Realizar Pedido",
      "checkout.firstName": "Nombre",
      "checkout.lastName": "Apellido",
      "checkout.email": "Correo Electrónico",
      "checkout.phone": "Teléfono",
      "checkout.address": "Dirección",
      "checkout.city": "Ciudad",
      "checkout.postalCode": "Código Postal",
      "checkout.guestCheckout": "Continuar como Invitado",
      "checkout.total": "Total",
      "checkout.productDiscounts": "Descuentos de Productos",
      "checkout.trust.secure": "Pago seguro",
      "checkout.trust.delivery": "Ventanas de entrega transparentes",
      "checkout.trust.refund": "Política de reembolso sencilla",
      "checkout.paymentMethod": "Método de Pago",
      "checkout.creditCard": "Tarjeta de Crédito",
      "checkout.creditCardDesc": "Paga con tu tarjeta de crédito o débito",
      "checkout.cash": "Pago en Efectivo",
      "checkout.cashDesc": "Paga en efectivo al momento de la entrega",
      "checkout.cashNotice":
        "Pagarás en efectivo cuando se entregue tu pedido. Por favor ten el monto exacto listo.",
      "checkout.placeOrderCash": "Realizar Pedido (Efectivo)",
      "checkout.enterDelivery": "Ingresa detalles de entrega",
      "checkout.completePurchase": "Completa tu compra",
      "checkout.backToCart": "Volver al Carrito",
      "checkout.whereDeliver": "¿Dónde debemos entregar tus productos?",
      "checkout.continueToPayment": "Continuar al Pago",
      "checkout.securelyComplete": "Completa tu compra de forma segura",
      "checkout.demoNotice":
        "Esta es una demostración. Usa el número de tarjeta 4242 4242 4242 4242 con cualquier fecha futura y CVV.",
      "checkout.cardholderName": "Nombre del Tarjetahabiente",
      "checkout.cardNumber": "Número de Tarjeta",
      "checkout.expiryDate": "Fecha de Vencimiento",
      "checkout.cvv": "CVV",
      "checkout.backToShipping": "Volver a Envío",
      "checkout.processing": "Procesando...",
      "checkout.orderSummary": "Resumen del Pedido",
      "checkout.subtotal": "Subtotal",
      "checkout.taxIVA": "Impuesto (IVA 16%)",
      "checkout.deliveryAddress": "Dirección de Entrega",

      // Authentication
      "auth.login": "Iniciar Sesión",
      "auth.register": "Crear Cuenta",
      "auth.welcome": "Bienvenido a KosherMarket",
      "auth.signInDescription": "Inicia sesión en tu cuenta o crea una nueva",
      "auth.email": "Correo Electrónico",
      "auth.password": "Contraseña",
      "auth.confirmPassword": "Confirmar Contraseña",
      "auth.firstName": "Nombre",
      "auth.lastName": "Apellido",
      "auth.name": "Nombre",
      "auth.forgotPassword": "¿Olvidó su Contraseña?",
      "auth.noAccount": "¿No tiene una cuenta?",
      "auth.hasAccount": "¿Ya tiene una cuenta?",

      // Dashboard
      "dashboard.orders": "Mis Pedidos",
      "dashboard.profile": "Perfil",
      "dashboard.orderHistory": "Historial de Pedidos",
      "dashboard.employee.title": "Panel de Empleado",
      "dashboard.employee.newOrders": "Nuevos Pedidos",
      "dashboard.admin.title": "Panel de Administrador",
      "dashboard.admin.products": "Gestionar Productos",
      "dashboard.admin.categories": "Gestionar Categorías",
      "dashboard.admin.users": "Gestionar Usuarios",
      "dashboard.admin.discounts": "Gestionar Descuentos",
      "dashboard.admin.analytics": "Análisis",

      // Orders
      "orders.status.pending": "Pendiente",
      "orders.status.preparing": "Preparando",
      "orders.status.ready": "Listo para Entrega",
      "orders.status.delivered": "Entregado",
      "orders.status.cancelled": "Cancelado",
      "orders.orderNumber": "Pedido #",
      "orders.date": "Fecha",
      "orders.status": "Estado",
      "orders.total": "Total",
      "orders.updateStatus": "Actualizar Estado",
      "orders.statusUpdated": "Estado del pedido actualizado exitosamente",
      "orders.viewCart": "Ver Carrito",
      "orders.cartContents": "Contenido del Carrito",
      "orders.emptyCart": "No hay artículos en este pedido",
      "orders.cartDetails": "Detalles del Carrito",
      "orders.details": "Detalles del Pedido",

      // Product
      "product.quantity": "Cant",
      "product.each": "c/u",
      "product.addToCart": "Agregar al Carrito",
      "product.itemsInCart": "{{count}} artículo en el carrito",
      "product.itemsInCart_other": "{{count}} artículos en el carrito",
      "product.trust.secure": "Pago seguro",
      "product.trust.delivery": "Ventanas de entrega confiables",
      "product.trust.returns": "Política de reembolso sencilla",

      // Common
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.edit": "Editar",
      "common.delete": "Eliminar",
      "common.add": "Agregar",
      "common.update": "Actualizar",
      "common.submit": "Enviar",
      "common.loading": "Cargando...",
      "common.more": "más",
      "common.error": "Error",
      "common.back": "Volver",
      "common.availableNow": "Disponible Ahora",
      "common.success": "Éxito",
      "common.required": "Requerido",
      "common.page": "Página",
      "common.of": "de",
      "common.showing": "Mostrando",
      "common.previous": "Anterior",
      "common.next": "Siguiente",
      "common.expand": "Expandir",
      "common.collapse": "Contraer",
      "common.brand": "Kosher Market",

      // Cookie Consent
      "cookieConsent.title": "Consentimiento de cookies",
      "cookieConsent.message":
        "Usamos cookies para análisis y para mejorar el sitio. Puedes aceptar o rechazar.",
      "cookieConsent.accept": "Aceptar",
      "cookieConsent.decline": "Rechazar",
      "cookieConsent.learnMore": "Política de privacidad",

      // Error Fallback
      "errorFallback.title": "Algo salió mal",
      "errorFallback.description":
        "Ocurrió un error inesperado. Por favor intenta de nuevo.",
      "errorFallback.details": "Detalles del error",
      "errorFallback.tryAgain": "Intentar de nuevo",

      // Categories
      "categories.fruits": "Frutas y Verduras",
      "categories.dairy": "Lácteos y Huevos",
      "categories.meat": "Carnes y Mariscos",
      "categories.bakery": "Panadería",
      "categories.pantry": "Productos Básicos",
      "categories.beverages": "Bebidas",
      "categories.snacks": "Bocadillos",
      "categories.household": "Artículos del Hogar",

      // Sorting and Filtering
      "products.sortBy": "Ordenar por",
      "products.sortBy.name": "Nombre A-Z",
      "products.sortBy.priceLow": "Precio: Menor a Mayor",
      "products.sortBy.priceHigh": "Precio: Mayor a Menor",
      "products.resultsFound": "productos encontrados",
      "products.tryAdjusting":
        "Intenta ajustar tus criterios de búsqueda o filtro",
      "products.clearFilters": "Limpiar Filtros",
      "products.lowStock": "Poco Stock",
      "products.save": "Ahorra",
      "products.inCart": "En Carrito",
      "products.inStock": "En Stock",
      "products.stock": "Stock",
      "products.add": "Agregar",
      "products.name": "Nombre",
      "products.allLoaded": "Todos los productos cargados",
      "products.description": "Descripción",
      "products.loadError": "Error al cargar producto",
      "products.backToProducts": "Volver a Productos",
      "products.off": "dto",
      "products.buy": "Compra",
      "products.get": "obtén",
      "products.free": "gratis",
      "products.discount": "Descuento",
      "products.activeDiscounts": "Descuentos Activos",
      "products.onlyLeft": "Solo queda {{count}}",
      "products.onlyLeft_other": "Solo quedan {{count}}",

      // Cart
      "cart.addProducts": "Agrega algunos productos para comenzar",
      "cart.subtotal": "Subtotal",
      "cart.tax": "Impuesto (IVA 16%)",

      // Dashboard
      "dashboard.backToStore": "Volver a la Tienda",
      "dashboard.welcomeBack": "¡Bienvenido de vuelta",
      "dashboard.trackRecent": "Rastrea tus pedidos recientes",
      "dashboard.noOrdersYet": "Aún no hay pedidos",
      "dashboard.startShopping": "Comenzar a Comprar",
      "dashboard.customer.title": "Panel de Cliente",
      "dashboard.customer.totalOrders": "Total de Pedidos",
      "dashboard.customer.recentOrders": "Pedidos Recientes",
      "dashboard.customer.orderStats": "Estadísticas de Pedidos",
      "dashboard.customer.pendingOrders": "Pedidos Pendientes",
      "dashboard.customer.completedOrders": "Pedidos Completados",
      "dashboard.customer.filterByStatus": "Filtrar por Estado",
      "dashboard.customer.allStatuses": "Todos los Estados",
      "dashboard.customer.noOrdersFound": "No se encontraron pedidos",
      "dashboard.customer.viewAllOrders": "Ver Todos los Pedidos",
      "dashboard.manageOrders": "Gestionar pedidos e inventario",
      "dashboard.manageStore": "Gestiona tu tienda",
      "dashboard.overview": "Resumen",
      "dashboard.totalProducts": "Productos Totales",
      "dashboard.ordersToday": "Pedidos Hoy",
      "dashboard.revenue": "Ingresos",
      "dashboard.manageCatalog": "Gestiona tu catálogo de productos",
      "dashboard.addProduct": "Agregar Producto",
      "dashboard.searchProducts": "Buscar productos...",
      "dashboard.product": "Producto",
      "dashboard.category": "Categoría",
      "dashboard.price": "Precio",
      "dashboard.stock": "Stock",
      "dashboard.status": "Estado",
      "dashboard.actions": "Acciones",
      "dashboard.active": "Activo",
      "dashboard.inactive": "Inactivo",
      "dashboard.organizeCategories": "Organiza tus categorías de productos",
      "dashboard.addCategory": "Agregar Categoría",
      "dashboard.productsCount": "productos",
      "dashboard.revenueOverview": "Resumen de Ingresos",
      "dashboard.ordersTrend": "Tendencia de Pedidos",
      "dashboard.salesByCategory": "Ventas por Categoría",
      "dashboard.customer": "Cliente",
      "dashboard.processOrders": "Procesar pedidos de clientes",
      "dashboard.filterByCategory": "Filtrar por categoría",
      "dashboard.allCategories": "Todas las Categorías",
      "dashboard.noProductsFound": "No se encontraron productos",
      "dashboard.noProducts": "No hay productos disponibles",
      "dashboard.noCategories": "No hay categorías disponibles",
      "dashboard.slug": "Slug",

      // Admin
      "admin.noCategory": "Sin Categoría",
      "admin.editProduct": "Editar Producto",
      "admin.addProduct": "Agregar Producto",
      "admin.products": "Productos",
      "admin.editProductDescription": "Actualizar información del producto",
      "admin.addProductDescription": "Crear un nuevo producto",
      "admin.productName": "Nombre del Producto",
      "admin.enterProductName": "Ingresa nombre del producto",
      "admin.description": "Descripción",
      "admin.enterDescription": "Ingresa descripción del producto",
      "admin.price": "Precio",
      "admin.stockQuantity": "Cantidad en Stock",
      "admin.category": "Categoría",
      "admin.categories": "Categorías",
      "admin.noCategories": "No hay categorías disponibles",
      "admin.selectCategory": "Seleccionar categoría",
      "admin.activeProduct": "Producto Activo",
      "admin.isActive": "Activo",
      "admin.imageUrl": "URL de Imagen",
      "admin.productImage": "Imagen del Producto",
      "admin.categoryImage": "Imagen de la Categoría",
      "admin.uploadImage": "Subir Imagen",
      "admin.cropImage": "Recortar Imagen",
      "admin.cropImageDescription":
        "Arrastra para reposicionar, usa el deslizador de zoom para ajustar el tamaño",
      "admin.zoom": "Zoom",
      "admin.cropInstructions":
        "💡 Arrastra la imagen para reposicionar y usa el deslizador de zoom para ajustar tu producto",
      "admin.processing": "Procesando...",
      "admin.applyCrop": "Aplicar Recorte",
      "admin.dimensions": "Dimensiones",
      "admin.originalSize": "Tamaño Original",
      "admin.optimizedSize": "Tamaño Optimizado",
      "admin.savings": "Ahorro",
      "admin.editCategory": "Editar Categoría",
      "admin.addCategory": "Agregar Categoría",
      "admin.editCategoryDescription": "Actualizar información de la categoría",
      "admin.addCategoryDescription": "Crear una nueva categoría",
      "admin.categoryName": "Nombre de la Categoría",
      "admin.enterCategoryName": "Ingresa nombre de la categoría",
      "admin.searchCategories": "Buscar categorías...",
      "admin.noSearchResults": "No se encontraron resultados",
      "admin.parentCategory": "Categoría Padre",
      "admin.noParent": "Sin Padre",
      "admin.parentCategoryDescription":
        "Selecciona una categoría padre para crear una subcategoría (máximo 2 niveles)",
      "admin.subcategoryOf": "Subcategoría de",
      "admin.subcategory": "Subcategoría",
      "admin.slug": "Slug",
      "admin.slugDescription":
        "Identificador amigable para URL (minúsculas, solo guiones)",
      "admin.confirmDelete": "Confirmar Eliminación",
      "admin.deleteProductConfirm":
        "¿Estás seguro de que quieres eliminar {{name}}? Esta acción no se puede deshacer.",
      "admin.deleteCategoryConfirm":
        "¿Estás seguro de que quieres eliminar {{name}}? Esta acción no se puede deshacer.",
      "admin.validation.requiredFields":
        "Por favor completa todos los campos requeridos",
      "admin.validation.slugExists": "Este slug ya existe",
      "admin.validation.categoryHasProducts":
        "No se puede eliminar una categoría que contiene productos",
      "admin.messages.productUpdated": "Producto actualizado exitosamente",
      "admin.messages.productAdded": "Producto agregado exitosamente",
      "admin.messages.productDeleted": "Producto eliminado exitosamente",
      "admin.messages.categoryUpdated": "Categoría actualizada exitosamente",
      "admin.messages.categoryAdded": "Categoría agregada exitosamente",
      "admin.messages.categoryDeleted": "Categoría eliminada exitosamente",
      "admin.fillRequiredFields":
        "Por favor completa todos los campos requeridos",
      "admin.productUpdated": "Producto actualizado exitosamente",
      "admin.productCreated": "Producto creado exitosamente",
      "admin.productDeleted": "Producto eliminado exitosamente",

      // Discounts
      "discounts.form.name": "Nombre",
      "discounts.form.code": "Código de Descuento",
      "discounts.form.description": "Descripción",
      "discounts.title": "Gestión de Descuentos",
      "discounts.subtitle":
        "Crear y gestionar códigos de descuento y promociones",
      "discounts.addDiscount": "Agregar Descuento",
      "discounts.editDiscount": "Editar Descuento",
      "discounts.createNew": "Crear Nuevo Descuento",
      "discounts.updateDetails":
        "Actualizar los detalles del descuento a continuación",
      "discounts.fillDetails":
        "Complete los detalles para crear un nuevo descuento",
      "discounts.table.code": "Código",
      "discounts.table.automatic": "Automático",
      "discounts.table.name": "Nombre",
      "discounts.table.type": "Tipo",
      "discounts.table.value": "Valor",
      "discounts.table.usage": "Uso",
      "discounts.table.status": "Estado",
      "discounts.table.dates": "Fechas",
      "discounts.table.actions": "Acciones",
      "discounts.totalDiscounts": "descuentos totales",
      "discounts.usageStatistics": "Estadísticas de Uso de Descuentos",
      "discounts.totalUses": "Usos Totales",
      "discounts.totalDiscountAmount": "Monto Total de Descuento",
      "discounts.avgPerUse": "Prom. por Uso",
      "discounts.recentUsage": "Uso Reciente",
      "discounts.usage.date": "Fecha",
      "discounts.usage.orderId": "ID de Pedido",
      "discounts.usage.userId": "ID de Usuario",
      "discounts.usage.discountAmount": "Monto de Descuento",
      "discounts.usage.guest": "Invitado",
      "discounts.status.active": "Activo",
      "discounts.status.inactive": "Inactivo",
      "discounts.type.percentage": "Porcentaje",
      "discounts.type.fixedAmount": "Cantidad Fija",
      "discounts.type.buyXGetY": "Compra X Lleva Y",
      "discounts.type.freeShipping": "Envío Gratis",
      "discounts.condition.minimumAmount": "Monto Mínimo",
      "discounts.condition.minimumQuantity": "Cantidad Mínima",
      "discounts.condition.specificProducts": "Productos Específicos",
      "discounts.condition.specificCategories": "Categorías Específicas",
      "discounts.condition.firstOrder": "Primera Orden",
      "discounts.condition.noCondition": "Sin Condición",
      "discounts.form.discountType": "Tipo de Descuento",
      "discounts.form.discountValue": "Valor del Descuento",
      "discounts.form.conditionType": "Tipo de Condición",
      "discounts.form.minimumAmount": "Monto Mínimo (MX$)",
      "discounts.form.minimumQuantity": "Cantidad Mínima",
      "discounts.form.usageLimit": "Límite de Uso",
      "discounts.form.maxDiscountAmount": "Monto Máximo de Descuento (MX$)",
      "discounts.form.startDate": "Fecha de Inicio",
      "discounts.form.endDate": "Fecha de Fin",
      "discounts.form.active": "Activo",
      "discounts.form.priority": "Prioridad",
      "discounts.form.priorityDescription":
        "Los descuentos de mayor prioridad se aplican primero (0 = más bajo)",
      "discounts.form.applyToSubcategories": "Aplicar a Subcategorías",
      "discounts.form.stackable": "Acumulable con otros descuentos",
      "discounts.form.cancel": "Cancelar",
      "discounts.form.create": "Crear",
      "discounts.form.update": "Actualizar",
      "discounts.form.discount": "Descuento",
      "discounts.form.codePlaceholder": "ej., AHORRA20",
      "discounts.form.unlimitedPlaceholder": "Ilimitado",
      "discounts.form.noLimitPlaceholder": "Sin límite",
      "discounts.form.automaticDiscount": "Descuento Automático",
      "discounts.form.automaticDiscountHelp":
        "Los descuentos automáticos se aplican según condiciones sin requerir código",
      "discounts.form.required": "*",
      "discounts.select.percentage": "Porcentaje (%)",
      "discounts.select.fixedAmount": "Cantidad Fija (MX$)",
      "discounts.select.buyXGetY": "Compra X Lleva Y",
      "discounts.select.freeShipping": "Envío Gratis",
      "discounts.select.noCondition": "Sin Condición",
      "discounts.select.minimumAmount": "Monto Mínimo",
      "discounts.select.minimumQuantity": "Cantidad Mínima",
      "discounts.select.firstOrder": "Solo Primera Orden",
      "discounts.form.selectProducts": "Seleccionar Productos",
      "discounts.form.selectCategories": "Seleccionar Categorías",
      "discounts.form.productsSelected": "producto(s) seleccionado(s)",
      "discounts.form.categoriesSelected": "categoría(s) seleccionada(s)",
      "discounts.form.searchProducts": "Buscar productos...",
      "discounts.form.searchCategories": "Buscar categorías...",
      "discounts.form.noProductsFound": "No se encontraron productos.",
      "discounts.form.noCategoriesFound": "No se encontraron categorías.",
      "discounts.form.noProductsAvailable":
        "No hay productos disponibles. Por favor, verifique la conexión API.",
      "discounts.form.noCategoriesAvailable":
        "No hay categorías disponibles. Por favor, verifique la conexión API.",
      "discounts.form.debugProducts": "Depuración: {count} productos cargados",

      // Checkout discount messages
      "checkout.discountCode": "Código de Descuento",
      "checkout.discountCodePlaceholder": "Ingrese el código de descuento",
      "checkout.discountApply": "Aplicar",
      "checkout.discountError.enterCode":
        "Por favor, ingrese un código de descuento",
      "checkout.discountError.alreadyApplied":
        "Este código de descuento ya está aplicado",
      "checkout.discountError.invalid": "Código de descuento inválido",
      "checkout.discountRemove": "Eliminar",
      "checkout.discountAmount": "Descuento",

      // Available Discounts Display
      "discounts.availableCoupons": "Cupones Disponibles",
      "discounts.automaticDiscounts": "Descuentos Automáticos",
      "discounts.off": "de descuento",
      "discounts.freeShipping": "Envío Gratis",
      "discounts.discount": "Descuento",
      "discounts.minimumAmount": "Órdenes superiores a MX${{amount}}",
      "discounts.minimumQuantity": "{{quantity}}+ artículos requeridos",
      "discounts.firstOrderOnly": "Solo primera orden",
      "discounts.noCondition": "Sin condiciones",
      "discounts.validUntil": "Válido hasta {{date}}",
      "discounts.apply": "Aplicar",
      "discounts.copyCode": "Copiar Código",
      "discounts.applied": "¡Descuento aplicado!",
      "discounts.codeCopied": "¡Código copiado al portapapeles!",
      "discounts.automatic": "Automático",
      "discounts.automaticApply": "Se aplica automáticamente al pagar",
      "discounts.noDiscountsAvailable":
        "No hay descuentos disponibles en este momento",

      // Discount Display Component
      "discounts.availableOffers": "Ofertas Disponibles",
      "discounts.clickToViewOffers":
        "Haz clic para ver descuentos y cupones disponibles",
      "discounts.couponCodes": "Códigos de Cupón",

      // Cart Discount Keys
      "cart.enterCouponCode": "Ingrese Código de Cupón",
      "cart.couponCodePlaceholder": "Ingrese código de cupón",
      "cart.apply": "Aplicar",
      "cart.applying": "Aplicando...",
      "cart.appliedDiscounts": "Descuentos Aplicados",
      "discounts.use": "Usar",
      "discounts.notEligible": "No Elegible",

      // Price Example Keys
      "discounts.originalPrice": "Precio Original",
      "discounts.yourPrice": "Tu Precio",
      "discounts.youSave": "Ahorras",
      "discounts.notApplicableToSample":
        "Se requiere mínimo MX${price} para este descuento",

      // Cart Specific Keys
      "cart.currentTotal": "Total Actual",
      "cart.afterDiscount": "Después del Descuento",
      "discounts.included": "incluido",

      // Discount Validation Keys
      "discounts.removed": "Descuento removido",
      "discounts.noLongerValid": "{{name}} ya no es válido para tu carrito",
      "discounts.validationError": "Error validando descuento {{name}}",

      // Discount Error Messages
      "discounts.errors.inactive": "Este descuento está actualmente inactivo",
      "discounts.errors.notStarted": "Este descuento comienza el {{date}}",
      "discounts.errors.expired": "Este descuento expiró el {{date}}",
      "discounts.errors.usageLimitReached":
        "Este descuento ha alcanzado su límite de uso",
      "discounts.errors.minimumAmountNotMet":
        "Pedido mínimo de MX${{required}} requerido (actual: MX${{current}})",
      "discounts.errors.minimumQuantityNotMet":
        "Mínimo {{required}} artículos requeridos (actual: {{current}})",
      "discounts.errors.notFirstOrder":
        "Este descuento es solo válido para clientes nuevos",

      // Table display
      "discounts.table.productsSelected": "Productos: {{count}} seleccionados",
      "discounts.table.categoriesSelected":
        "Categorías: {{count}} seleccionadas",
      "discounts.appliesTo.allProducts": "Se aplica a todos los productos",
      "discounts.table.dateFrom": "Desde:",
      "discounts.table.dateTo": "Hasta:",

      "admin.categoryUpdated": "Categoría actualizada exitosamente",
      "admin.categoryCreated": "Categoría creada exitosamente",
      "admin.categoryDeleted": "Categoría eliminada exitosamente",
      "admin.product": "Producto",
      "admin.stock": "Stock",
      "admin.status": "Estado",
      "admin.actions": "Acciones",

      // Dashboard Missing Keys
      "dashboard.manageProducts": "Gestiona tu catálogo de productos",
      "dashboard.admin.orders": "Gestionar Pedidos",
      "dashboard.admin.userUpdated": "Usuario actualizado exitosamente",
      "dashboard.admin.userRoleUpdated":
        "Rol de usuario actualizado exitosamente",
      "dashboard.admin.manageUsers": "Gestiona cuentas de usuario y permisos",
      "dashboard.admin.role": "Rol",
      "dashboard.admin.cashPayment": "Pago en Efectivo",
      "dashboard.admin.enabled": "Habilitado",
      "dashboard.admin.disabled": "Deshabilitado",
      "dashboard.admin.systemUser": "Usuario del Sistema",
      "dashboard.admin.customer": "Cliente",
      "dashboard.admin.roles.admin": "Administrador",
      "dashboard.admin.roles.employee": "Empleado",
      "dashboard.admin.roles.client": "Cliente",
      "dashboard.manageAllOrders": "Gestiona todos los pedidos de clientes",

      // Common Missing Keys
      "common.actions": "Acciones",
      "common.name": "Nombre",

      // Order Success
      "orderSuccess.confirmed": "¡Pedido Confirmado!",
      "orderSuccess.thankYou":
        "Gracias por tu compra. Tu pedido ha sido realizado exitosamente.",
      "orderSuccess.orderNumber": "Número de Pedido",
      "orderSuccess.estimatedDelivery": "Entrega Estimada",
      "orderSuccess.businessDays": "2-3 días hábiles",
      "orderSuccess.whatNext": "¿Qué sigue ahora?",
      "orderSuccess.orderConfirmation": "Confirmación del Pedido",
      "orderSuccess.emailConfirmation":
        "Recibirás un correo de confirmación en breve",
      "orderSuccess.orderPreparation": "Preparación del Pedido",
      "orderSuccess.teamPrepare":
        "Nuestro equipo preparará tus productos frescos",
      "orderSuccess.delivery": "Entrega",
      "orderSuccess.orderDelivered": "Tu pedido será entregado en tu dirección",
      "orderSuccess.viewOrderDetails": "Ver Detalles del Pedido",
      "orderSuccess.continueShopping": "Continuar Comprando",
      "orderSuccess.needHelp": "¿Necesitas ayuda con tu pedido?",
      "orderSuccess.contactSupport": "Contactar Soporte",

      // Authentication Guest
      "auth.continueGuest": "Continuar como Invitado",
      "auth.continueWithGoogle": "Continuar con Google",
      "auth.orEmail": "o inicia sesión con correo",

      // Profile
      "profile.name": "Nombre",
      "profile.email": "Correo Electrónico",
      "profile.role": "Rol",
      "profile.manageAccount": "Gestiona la información de tu cuenta",

      // Toast Messages
      "toast.loginSuccess": "¡Inicio de sesión exitoso!",
      "toast.loginError": "Correo electrónico o contraseña inválidos",
      "toast.loginErrorGeneral": "Ocurrió un error durante el inicio de sesión",
      "toast.passwordsNotMatch": "Las contraseñas no coinciden",
      "toast.passwordTooShort":
        "La contraseña debe tener al menos 6 caracteres",
      "toast.accountCreated": "¡Cuenta creada exitosamente!",
      "toast.accountCreateFailed": "Error al crear la cuenta",
      "toast.registrationError": "Ocurrió un error durante el registro",
      "toast.pleaseLogin":
        "Por favor inicia sesión para agregar artículos al carrito",
      "toast.notEnoughStock": "No hay suficiente stock disponible",
      "toast.addedToCart": "agregado al carrito",
      "toast.removedFromCart": "Artículo eliminado del carrito",
      "toast.cartCleared": "Carrito vaciado",
      "toast.failedToAddToCart": "Error al agregar artículo al carrito",
      "toast.failedToRemoveFromCart": "Error al eliminar artículo del carrito",
      "toast.failedToUpdateCart": "Error al actualizar el carrito",
      "toast.fillRequiredFields":
        "Por favor completa todos los campos requeridos",
      "toast.orderPlaced": "¡Pedido realizado exitosamente!",
      "toast.orderPlacedCash":
        "¡Pedido realizado! Se cobrará en efectivo al entregar.",
      "toast.paymentFailed": "El pago falló. Por favor intenta de nuevo.",
      "toast.creatingAccount": "Creando cuenta...",

      "toast.discountsFetchFailed": "No se pudieron cargar los descuentos",
      "toast.discountUpdated": "Descuento actualizado",
      "toast.discountCreated": "Descuento creado",
      "toast.discountSaveFailed": "No se pudo guardar el descuento",
      "toast.discountDeleted": "Descuento eliminado",
      "toast.discountDeleteFailed": "No se pudo eliminar el descuento",
      "toast.discountUsageFetchFailed":
        "No se pudo cargar el uso del descuento",

      // Footer
      "footer.company.title": "Kosher Market",
      "footer.company.description":
        "Tu destino de confianza para productos kosher de calidad entregados directamente a tu puerta.",
      "footer.tagline": "Productos kosher premium entregados con cuidado.",
      "footer.quickLinks.title": "Enlaces Rápidos",
      "footer.quickLinks.home": "Inicio",
      "footer.quickLinks.products": "Productos",
      "footer.quickLinks.about": "Acerca de",
      "footer.quickLinks.myAccount": "Mi Cuenta",
      "footer.quickLinks.account": "Mi Cuenta",
      "footer.legal.title": "Legal",
      "footer.legal.privacy": "Política de Privacidad",
      "footer.legal.terms": "Términos de Servicio",
      "footer.legal.refund": "Política de Reembolso",
      "footer.contact.title": "Contacto",
      "footer.contact.phone": "Teléfono",
      "footer.contact.email": "Correo",
      "footer.contact.address": "Dirección",
      "footer.contact.addressLine": "Cancún, Quintana Roo, México",
      "footer.followUs": "Síguenos",
      "footer.copyright":
        "© 2024 Kosher Market. Todos los derechos reservados.",
      "footer.developedBy": "Desarrollado por",
      "footer.trust.certified": "Kosher certificado",
      "footer.trust.supervised": "Supervisión rabínica",
      "footer.trust.delivery": "Entrega confiable",
      "footer.trust.windows": "Ventanas de entrega claras",
      "footer.trust.secure": "Pagos seguros",
      "footer.trust.protected": "Checkout encriptado",

      // Header
      "header.tagline": "Productos kosher premium",
      "header.trust.certified": "Solo productos kosher",
      "header.trust.delivery": "Entrega el mismo día en Cancún",
      "header.trust.secure": "Pago seguro",

      // About Page
      "about.title": "Acerca de Kosher Market",
      "about.subtitle":
        "Llevando productos kosher de calidad directamente a tu puerta",
      "about.story.title": "Nuestra Historia",
      "about.story.paragraph1":
        "Kosher Market fue fundado con una simple misión: hacer que los productos kosher de alta calidad sean accesibles para todos en nuestra comunidad. Lo que comenzó como una pequeña operación local ha crecido hasta convertirse en un mercado en línea integral que sirve a familias en toda la región.",
      "about.story.paragraph2":
        "Entendemos la importancia de mantener los estándares de kashrut mientras también cumplimos con las necesidades modernas del consumidor. Por eso, seleccionamos cuidadosamente nuestra selección para incluir solo productos kosher certificados de proveedores y fabricantes confiables.",
      "about.story.paragraph3":
        "Nuestro equipo se dedica a brindar un servicio al cliente excepcional, precios competitivos y opciones de entrega convenientes. Ya sea que estés preparándote para Shabat, una festividad o comidas cotidianas, estamos aquí para servirte.",
      "about.ourStory.title": "Nuestra Historia",
      "about.ourStory.text1":
        "Kosher Market fue fundado con una simple misión: hacer que los productos kosher de alta calidad sean accesibles para todos en nuestra comunidad. Lo que comenzó como una pequeña tienda familiar ha crecido hasta convertirse en la fuente de confianza de la región para alimentos kosher y artículos para el hogar.",
      "about.ourStory.text2":
        "Entendemos la importancia de mantener las leyes dietéticas kosher y nos enorgullece ofrecer una amplia selección de productos certificados de proveedores confiables alrededor del mundo. Nuestro equipo dedicado trabaja incansablemente para asegurar que cada producto cumpla con los más altos estándares de certificación kosher.",
      "about.ourStory.text3":
        "Hoy servimos a cientos de familias, ofreciendo entrega conveniente y un servicio al cliente excepcional. Nos comprometemos a crecer con nuestra comunidad mientras mantenemos los valores de calidad y servicio que nos definen.",
      "about.mission.title": "Nuestra Misión",
      "about.mission.description":
        "Proporcionar a nuestra comunidad acceso conveniente a los productos kosher de más alta calidad, entregados con cuidado y atención al detalle. Nos esforzamos por hacer que las compras kosher sean fáciles, asequibles y confiables para cada hogar.",
      "about.mission.text":
        "Proporcionar productos kosher auténticos y de alta calidad con un servicio excepcional, facilitando a las familias el mantenimiento de su estilo de vida kosher. Nos esforzamos por crear una experiencia de compras sin problemas que respete tanto las necesidades tradicionales como modernas.",
      "about.whyChooseUs": "¿Por Qué Elegirnos?",
      "about.features.quality.title": "Productos de Calidad",
      "about.features.quality.description":
        "Todos los productos son cuidadosamente seleccionados y certificados como kosher",
      "about.features.kosher.title": "Certificación Kosher",
      "about.features.kosher.description":
        "Certificación completa de rabinos de confianza y organizaciones kosher",
      "about.features.delivery.title": "Entrega Rápida",
      "about.features.delivery.description":
        "Servicio de entrega confiable directamente a tu puerta",
      "about.features.secure.title": "Compra Segura",
      "about.features.secure.description":
        "Tu información de pago siempre está protegida y segura",
      "about.features.payment.title": "Pago Seguro",
      "about.features.payment.description":
        "Transacciones seguras con múltiples opciones de pago",
      "about.features.support.title": "Atención al Cliente 24/7",
      "about.features.support.description":
        "Nuestro equipo dedicado está aquí para ayudarte en cualquier momento",
      "about.features.certified.title": "Totalmente Certificado",
      "about.features.certified.description":
        "Orgullosamente certificados y cumplimos con todas las regulaciones",
      "about.cta.title": "¿Listo para empezar a comprar?",
      "about.cta.description":
        "Únete a cientos de familias satisfechas que confían en Kosher Market para sus necesidades kosher",
      "about.cta.contact": "Llámanos",
      "about.cta.call": "Llámanos",
      "about.cta.whatsapp": "Chatea en WhatsApp",

      // Privacy Policy Page
      "privacy.title": "Política de Privacidad",
      "privacy.lastUpdated": "Última actualización",
      "privacy.introduction":
        "En Kosher Market, estamos comprometidos a proteger tu privacidad y garantizar la seguridad de tu información personal. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos tus datos cuando utilizas nuestro sitio web y servicios.",
      "privacy.section1.title": "Información que Recopilamos",
      "privacy.section1.text":
        "Recopilamos información que nos proporcionas directamente, incluyendo:\n\n• Datos personales (nombre, correo electrónico, número de teléfono)\n• Dirección de envío e información de contacto\n• Información de pago (procesada de forma segura a través de nuestros socios de pago)\n• Historial de pedidos y preferencias\n• Preferencias de comunicación\n\nTambién recopilamos automáticamente cierta información sobre tu dispositivo y cómo interactúas con nuestro sitio web, incluyendo dirección IP, tipo de navegador y patrones de uso.",
      "privacy.section2.title": "Cómo Usamos Tu Información",
      "privacy.section2.text":
        "Usamos la información que recopilamos para:\n\n• Procesar y cumplir con tus pedidos\n• Comunicarnos contigo sobre tus pedidos y cuenta\n• Proporcionar soporte al cliente\n• Mejorar nuestros productos y servicios\n• Enviar comunicaciones promocionales (con tu consentimiento)\n• Prevenir fraude y mejorar la seguridad\n• Cumplir con obligaciones legales\n\nNunca vendemos tu información personal a terceros.",
      "privacy.section3.title": "Protección de Datos y Seguridad",
      "privacy.section3.text":
        "Implementamos medidas de seguridad estándar de la industria para proteger tu información personal contra acceso no autorizado, divulgación o mal uso. Esto incluye:\n\n• Transmisión de datos encriptada (SSL/TLS)\n• Procesamiento seguro de pagos\n• Auditorías de seguridad regulares\n• Controles de acceso y autenticación\n• Capacitación de empleados en protección de datos\n\nAunque nos esforzamos por proteger tu información, ningún método de transmisión por Internet es 100% seguro.",
      "privacy.section4.title": "Cookies y Seguimiento",
      "privacy.section4.text":
        "Usamos cookies y tecnologías similares para:\n\n• Recordar tus preferencias y configuraciones\n• Entender cómo usas nuestro sitio web\n• Mejorar tu experiencia de navegación\n• Proporcionar contenido personalizado\n\nPuedes controlar las cookies a través de la configuración de tu navegador. Sin embargo, deshabilitar las cookies puede afectar tu capacidad de usar ciertas funciones de nuestro sitio web.",
      "privacy.section5.title": "Tus Derechos",
      "privacy.section5.text":
        "Tienes derecho a:\n\n• Acceder a tu información personal\n• Corregir datos inexactos\n• Solicitar la eliminación de tus datos\n• Oponerte al procesamiento de tus datos\n• Retirar el consentimiento en cualquier momento\n• Exportar tus datos\n\nPara ejercer estos derechos, contáctanos usando la información a continuación.",
      "privacy.section6.title": "Cambios a Esta Política",
      "privacy.section6.text":
        "Podemos actualizar esta Política de Privacidad de vez en cuando. Te notificaremos sobre cualquier cambio significativo publicando la nueva política en nuestro sitio web y actualizando la fecha de 'Última actualización'.\n\nTu uso continuo de nuestros servicios después de cualquier cambio indica tu aceptación de la política actualizada.",
      "privacy.questions": "¿Preguntas sobre Privacidad?",
      "privacy.contactUs":
        "Si tienes alguna pregunta o inquietud sobre esta Política de Privacidad o nuestras prácticas de datos, contáctanos:",
      "privacy.emailUs": "Envíanos un correo",
      "privacy.callUs": "Llámanos",

      // Terms & Conditions
      "terms.title": "Términos y Condiciones",
      "terms.lastUpdated": "Última actualización",
      "terms.introduction":
        "Bienvenido a Kosher Market. Al acceder y usar nuestro sitio web y servicios, aceptas cumplir con los siguientes términos y condiciones. Por favor léelos cuidadosamente.",
      "terms.section1.title": "Aceptación de Términos",
      "terms.section1.text":
        "Al usar el sitio web y servicios de Kosher Market, reconoces que has leído, entendido y aceptas estar sujeto a estos Términos y Condiciones. Si no estás de acuerdo con alguna parte de estos términos, por favor no uses nuestros servicios.\n\nNos reservamos el derecho de modificar estos términos en cualquier momento. El uso continuado de nuestros servicios después de cambios constituye aceptación de los términos modificados.",
      "terms.section2.title": "Pedidos y Pagos",
      "terms.section2.text":
        "• Todos los pedidos están sujetos a disponibilidad de productos y aceptación por Kosher Market\n• Los precios están en Pesos Mexicanos (MXN) y sujetos a cambios sin previo aviso\n• El pago debe completarse al momento de realizar el pedido\n• Aceptamos tarjetas de crédito principales y pago en efectivo contra entrega\n• Aceptas proporcionar información de pago y entrega precisa\n• La confirmación del pedido se enviará por correo electrónico tras el pago exitoso",
      "terms.section3.title": "Términos de Entrega",
      "terms.section3.text":
        "• Los tiempos de entrega son estimados y no garantizados\n• Entregamos en direcciones especificadas dentro de nuestra área de servicio\n• Alguien debe estar presente para recibir la entrega\n• No somos responsables de retrasos causados por circunstancias fuera de nuestro control\n• Pueden aplicar tarifas de entrega según ubicación y valor del pedido\n• Las instrucciones especiales de entrega deben proporcionarse al pagar",
      "terms.section4.title": "Información del Producto",
      "terms.section4.text":
        "• Nos esforzamos por proporcionar descripciones e imágenes precisas de los productos\n• Todos los productos están certificados kosher por autoridades reconocidas\n• El empaque real del producto puede variar de las imágenes mostradas\n• Nos reservamos el derecho de sustituir productos de igual o mayor valor si los artículos no están disponibles\n• Las certificaciones kosher se verifican al momento de listar pero pueden cambiar",
      "terms.section5.title": "Responsabilidades del Usuario",
      "terms.section5.text":
        "• Debes tener al menos 18 años para usar nuestros servicios\n• Eres responsable de mantener la confidencialidad de la cuenta\n• Aceptas no usar nuestros servicios para propósitos ilegales\n• Debes proporcionar información precisa y completa\n• Aceptas notificarnos sobre cualquier uso no autorizado de la cuenta\n• No se permiten múltiples cuentas del mismo usuario",
      "terms.section6.title": "Limitación de Responsabilidad",
      "terms.section6.text":
        "Kosher Market no será responsable de:\n• Daños indirectos, incidentales o consecuentes\n• Pérdida de ganancias u oportunidades de negocio\n• Retrasos en la entrega debido a circunstancias fuera de nuestro control\n• Problemas de calidad del producto cubiertos por nuestra política de reembolso\n• Fallos de servicios de terceros\n\nNuestra responsabilidad total está limitada al valor de tu pedido.",
      "terms.questions": "¿Preguntas sobre estos Términos?",
      "terms.contactUs":
        "Si tienes alguna pregunta sobre estos Términos y Condiciones, por favor contáctanos:",
      "terms.emailUs": "Enviar Correo",
      "terms.callUs": "Llamar",

      // Refund Policy
      "refund.title": "Política de Reembolso",
      "refund.lastUpdated": "Última actualización",
      "refund.introduction":
        "En Kosher Market, queremos que estés completamente satisfecho con tu compra. Esta Política de Reembolso describe nuestras pautas para devoluciones, reembolsos e intercambios.",
      "refund.section1.title": "Política General de Reembolso",
      "refund.section1.text":
        "Ofrecemos reembolsos o reemplazos para productos que:\n• Lleguen dañados o defectuosos\n• Sean significativamente diferentes de la descripción\n• Estén pasados de su fecha de caducidad al momento de la entrega\n• Falten en tu pedido\n\nLos reembolsos se procesan al método de pago original dentro de 5-7 días hábiles después de la aprobación. Para pagos en efectivo, los reembolsos se emiten como crédito en la tienda.",
      "refund.section2.title": "Elegibilidad para Reembolsos",
      "refund.section2.text":
        "Para ser elegible para un reembolso, debes:\n• Contactarnos dentro de las 24 horas de la entrega\n• Proporcionar fotos de productos dañados o defectuosos\n• Tener el producto en su empaque original (cuando sea posible)\n• Proporcionar tu número de pedido e información de contacto\n\nNota: Los artículos perecederos no pueden devolverse por razones de higiene y seguridad, pero pueden calificar para reemplazo si son defectuosos.",
      "refund.section3.title": "Cronograma del Proceso de Reembolso",
      "refund.section3.text":
        "1. Contáctanos: Comunícate dentro de las 24 horas de la entrega\n2. Revisión: Nuestro equipo revisa tu solicitud dentro de 1-2 días hábiles\n3. Aprobación: Los reembolsos aprobados se procesan dentro de 24 horas\n4. Reembolso: El dinero regresa a tu cuenta en 5-7 días hábiles\n\nPara problemas urgentes, por favor llámanos directamente al +52 998 550 5030.",
      "refund.section4.title": "Artículos No Reembolsables",
      "refund.section4.text":
        "Los siguientes artículos no son elegibles para reembolso:\n• Productos abiertos o consumidos\n• Artículos de pedido especial o personalizados\n• Tarjetas de regalo y artículos promocionales\n• Productos dañados debido a mal uso\n• Artículos no reportados dentro de 24 horas\n• Productos devueltos sin autorización previa",
      "refund.section5.title": "Métodos de Reembolso",
      "refund.section5.text":
        "Los reembolsos se emiten según tu método de pago original:\n\n• Tarjeta de Crédito/Débito: Reembolsado a la misma tarjeta dentro de 5-7 días hábiles\n• Pago en Efectivo: Emitido como crédito en la tienda para compras futuras\n• Transferencia Bancaria: Requiere tus datos bancarios, procesado dentro de 5-7 días hábiles\n\nEl crédito en la tienda nunca expira y puede usarse para cualquier compra futura.",
      "refund.section6.title": "Intercambios y Reemplazos",
      "refund.section6.text":
        "Ofrecemos reemplazos gratuitos para:\n• Productos dañados recibidos\n• Artículos incorrectos entregados\n• Productos con problemas de calidad\n\nLos reemplazos se envían sin costo adicional. Si el producto no está disponible, ofrecemos un reembolso completo o crédito en la tienda. Contáctanos para coordinar un reemplazo.",
      "refund.questions": "¿Preguntas sobre Reembolsos?",
      "refund.contactUs":
        "Si tienes alguna pregunta sobre nuestra Política de Reembolso o necesitas solicitar un reembolso, por favor contáctanos:",
      "refund.emailUs": "Enviar Correo",
      "refund.callUs": "Llamar",
    },
  },
  he: {
    translation: {
      "nav.products": "מוצרים",
      // Navigation
      "nav.home": "בית",
      "nav.categories": "קטגוריות",
      "nav.cart": "עגלה",
      "nav.login": "התחברות",
      "nav.register": "הרשמה",
      "nav.logout": "התנתקות",
      "nav.dashboard": "לוח בקרה",
      "nav.language": "שפה",
      "nav.discounts": "הנחות",
      "nav.about": "אודות",

      // Homepage
      "home.hero.title": "מוצרים כשרים במשלוח עד הבית",
      "home.hero.subtitle": "הזמינו מוצרים כשרים עם משלוח בקנקון",
      "home.hero.cta": "התחל לקנות",
      "home.hero.badge": "מוצרים כשרים במקסיקו",
      "home.hero.secondary": "צפה במבצעים",
      "home.hero.secure": "תשלום מאובטח",
      "home.hero.delivery": "משלוח זמין",
      "home.hero.deliveryStatus": "סטטוס משלוח",
      "home.hero.onTheWay": "בדרך אליך!",
      "home.featured": "מוצרים מומלצים",
      "home.categories": "קנייה לפי קטגוריה",
      "home.cta.title": "מוכן להתחיל לקנות?",
      "home.cta.subtitle": "עיין בקטלוג המלא שלנו וקבל מוצרים כשרים עד אליכם.",
      "home.cta.button": "צפה בכל המוצרים",
      "home.discounts.title": "מבצעים פעילים",
      "home.discounts.subtitle": "הנחות מוחלות בקופה בהתאם",
      "home.trust.quality": "מותגים כשרים שנבחרו בקפידה",
      "home.trust.qualityDetail": "מבחר ממוקד שנבחר בקפידה",
      "home.trust.pricing": "תמחור ושקיפות מלאה",
      "home.trust.pricingDetail": "מחיר ברור בקופה",
      "home.trust.support": "תמיכה אמיתית כשצריך",
      "home.trust.supportDetail": "טלפון / וואטסאפ / אימייל",

      // Discounts Page
      "discountsPage.badge": "הצעות מיוחדות",
      "discountsPage.title": "מוצרים וקטגוריות במבצע",
      "discountsPage.subtitle":
        "גלו הצעות מדהימות על המוצרים והקטגוריות האהובים עליכם",
      "discountsPage.loading": "טוען הנחות...",
      "discountsPage.noDiscounts": "אין הנחות פעילות",
      "discountsPage.noDiscountsDescription":
        "בדקו שוב בקרוב למבצעים חדשים והצעות מיוחדות על המוצרים האהובים עליכם",
      "discountsPage.categoriesTitle": "קטגוריות במבצע",
      "discountsPage.categoriesSubtitle":
        "עיינו בקטגוריות שלמות עם הנחות מיוחדות",
      "discountsPage.productsTitle": "מוצרים במבצע",
      "discountsPage.productsSubtitle": "הצעות מעולות על מוצרים בודדים",

      // Pagination
      "pagination.previous": "הקודם",
      "pagination.next": "הבא",
      "pagination.pageOf": "עמוד {{current}} מתוך {{total}}",

      // Products
      "products.search": "חיפוש מוצרים...",
      "products.notFound": "לא נמצאו מוצרים",
      "products.addToCart": "הוסף לעגלה",
      "products.outOfStock": "אזל מהמלאי",
      "products.price": "מחיר",
      "products.category": "קטגוריה",
      "products.all": "כל המוצרים",
      "products.allProducts": "כל המוצרים",
      "products.allCategories": "כל הקטגוריות",
      "products.categories": "קטגוריות",
      "products.filters": "מסננים",
      "products.viewAll": "צפה בהכל",
      "products.results": "תוצאות",
      "products.noProductsFound": "לא נמצאו מוצרים",
      "products.tryDifferentSearch": "נסה חיפוש אחר או עיין בקטגוריות שלנו",
      "products.endOfResults": "הגעת לסוף התוצאות",
      "products.loadingMore": "טוען מוצרים נוספים...",
      "products.sortByName": "שם (א-ת)",
      "products.priceLowToHigh": "מחיר: נמוך לגבוה",
      "products.priceHighToLow": "מחיר: גבוה לנמוך",
      "products.featured": "מומלץ",
      "products.addedToWishlist": "נוסף למועדפים",
      "products.removedFromWishlist": "הוסר מהמועדפים",

      // Cart
      "cart.title": "עגלת קניות",
      "cart.empty": "העגלה שלך ריקה",
      "cart.continueShopping": "המשך קניות",
      "cart.checkout": "לתשלום",
      "cart.total": "סה״כ",
      "cart.quantity": "כמות",
      "cart.remove": "הסר",
      "cart.update": "עדכן",
      "cart.clear": "רוקן עגלה",
      "cart.items": "{{count}} פריטים",
      "cart.items_plural": "{{count}} פריטים",
      "cart.reviewItems": "סקור את הפריטים שלך והמשך לתשלום",
      "cart.trust.secure": "תשלום מאובטח",
      "cart.trust.delivery": "חלונות אספקה ברורים",
      "cart.trust.refund": "החזרים ללא סיבוכים",

      // Checkout
      "checkout.title": "תשלום",
      "checkout.shipping": "פרטי משלוח",
      "checkout.payment": "פרטי תשלום",
      "checkout.review": "סקירת הזמנה",
      "checkout.placeOrder": "בצע הזמנה",
      "checkout.firstName": "שם פרטי",
      "checkout.lastName": "שם משפחה",
      "checkout.email": "אימייל",
      "checkout.phone": "טלפון",
      "checkout.address": "כתובת",
      "checkout.city": "עיר",
      "checkout.postalCode": "מיקוד",
      "checkout.guestCheckout": "המשך כאורח",
      "checkout.total": "סה״כ",
      "checkout.productDiscounts": "הנחות על מוצרים",
      "checkout.trust.secure": "תשלום מאובטח",
      "checkout.trust.delivery": "חלונות אספקה שקופים",
      "checkout.trust.refund": "מדיניות החזרים קלה",
      "checkout.paymentMethod": "אמצעי תשלום",
      "checkout.creditCard": "כרטיס אשראי",
      "checkout.creditCardDesc": "שלם עם כרטיס האשראי או החיוב שלך",
      "checkout.cash": "תשלום במזומן",
      "checkout.cashDesc": "שלם במזומן בזמן המסירה",
      "checkout.cashNotice":
        "תשלם במזומן כאשר ההזמנה תימסר. אנא הכן את הסכום המדויק.",
      "checkout.placeOrderCash": "בצע הזמנה (מזומן)",

      // Authentication
      "auth.login": "התחברות",
      "auth.register": "יצירת חשבון",
      "auth.welcome": "ברוכים הבאים ל-KosherMarket",
      "auth.signInDescription": "התחבר לחשבון שלך או צור חדש",
      "auth.email": "כתובת אימייל",
      "auth.password": "סיסמה",
      "auth.confirmPassword": "אישור סיסמה",
      "auth.firstName": "שם פרטי",
      "auth.lastName": "שם משפחה",
      "auth.name": "שם",
      "auth.forgotPassword": "שכחת סיסמה?",
      "auth.noAccount": "אין לך חשבון?",
      "auth.hasAccount": "יש לך כבר חשבון?",

      // Dashboard
      "dashboard.orders": "ההזמנות שלי",
      "dashboard.profile": "פרופיל",
      "dashboard.orderHistory": "היסטוריית הזמנות",
      "dashboard.employee.title": "לוח בקרה עובד",
      "dashboard.employee.newOrders": "הזמנות חדשות",
      "dashboard.admin.title": "לוח בקרה מנהל",
      "dashboard.admin.products": "ניהול מוצרים",
      "dashboard.admin.categories": "ניהול קטגוריות",
      "dashboard.admin.users": "ניהול משתמשים",
      "dashboard.admin.discounts": "ניהול הנחות",
      "dashboard.admin.analytics": "ניתוח נתונים",

      // Orders
      "orders.status.pending": "ממתין",
      "orders.status.preparing": "בהכנה",
      "orders.status.ready": "מוכן למשלוח",
      "orders.status.delivered": "נמסר",
      "orders.status.cancelled": "מבוטל",
      "orders.orderNumber": "הזמנה #",
      "orders.date": "תאריך",
      "orders.status": "סטטוס",
      "orders.total": "סה״כ",
      "orders.updateStatus": "עדכן סטטוס",
      "orders.statusUpdated": "סטטוס ההזמנה עודכן בהצלחה",
      "orders.viewCart": "צפה בעגלה",
      "orders.cartContents": "תוכן העגלה",
      "orders.emptyCart": "אין פריטים בהזמנה זו",
      "orders.cartDetails": "פרטי העגלה",
      "orders.details": "פרטי ההזמנה",

      // Product
      "product.quantity": "כמות",
      "product.each": "ליחידה",
      "product.addToCart": "הוסף לעגלה",
      "product.itemsInCart": "פריט אחד בעגלה",
      "product.itemsInCart_other": "{{count}} פריטים בעגלה",
      "product.trust.secure": "תשלום מאובטח",
      "product.trust.delivery": "חלונות אספקה אמינים",
      "product.trust.returns": "מדיניות החזרים קלה",

      // Common
      "common.save": "שמור",
      "common.cancel": "בטל",
      "common.edit": "ערוך",
      "common.delete": "מחק",
      "common.add": "הוסף",
      "common.update": "עדכן",
      "common.submit": "שלח",
      "common.loading": "טוען...",
      "common.more": "נוספים",
      "common.error": "שגיאה",
      "common.success": "הצלחה",
      "common.required": "נדרש",
      "common.back": "חזור",
      "common.availableNow": "זמין כעת",
      "common.page": "עמוד",
      "common.of": "מתוך",
      "common.showing": "מציג",
      "common.previous": "הקודם",
      "common.next": "הבא",
      "common.expand": "הרחב",
      "common.collapse": "כווץ",
      "common.brand": "Kosher Market",

      // Cookie Consent
      "cookieConsent.title": "הסכמה לעוגיות",
      "cookieConsent.message":
        "אנחנו משתמשים בעוגיות לניתוח נתונים ולשיפור האתר. אפשר לאשר או לדחות.",
      "cookieConsent.accept": "אשר",
      "cookieConsent.decline": "דחה",
      "cookieConsent.learnMore": "מדיניות פרטיות",

      // Error Fallback
      "errorFallback.title": "משהו השתבש",
      "errorFallback.description": "אירעה שגיאה לא צפויה. נסו שוב.",
      "errorFallback.details": "פרטי שגיאה",
      "errorFallback.tryAgain": "נסו שוב",

      // Categories
      "categories.fruits": "פירות וירקות",
      "categories.dairy": "חלב וביצים",
      "categories.meat": "בשר ודגים",
      "categories.bakery": "מאפייה",
      "categories.pantry": "מוצרי יסוד",
      "categories.beverages": "משקאות",
      "categories.snacks": "חטיפים",
      "categories.household": "מוצרי בית",

      // Sorting and Filtering
      "products.sortBy": "מיין לפי",
      "products.sortBy.name": "שם א-ת",
      "products.sortBy.priceLow": "מחיר: נמוך לגבוה",
      "products.sortBy.priceHigh": "מחיר: גבוה לנמוך",
      "products.resultsFound": "מוצרים נמצאו",
      "products.tryAdjusting": "נסה לשנות את קריטריוני החיפוש או הסינון",
      "products.clearFilters": "נקה מסננים",
      "products.lowStock": "מלאי נמוך",
      "products.save": "חסוך",
      "products.inCart": "בעגלה",
      "products.inStock": "במלאי",
      "products.stock": "מלאי",
      "products.add": "הוסף",
      "products.name": "שם",
      "products.allLoaded": "כל המוצרים נטענו",
      "products.description": "תיאור",
      "products.loadError": "שגיאה בטעינת המוצר",
      "products.backToProducts": "חזור למוצרים",
      "products.off": "הנחה",
      "products.buy": "קנה",
      "products.get": "קבל",
      "products.free": "חינם",
      "products.discount": "הנחה",
      "products.activeDiscounts": "הנחות פעילות",
      "products.onlyLeft": "נשאר רק {{count}}",
      "products.onlyLeft_other": "נשארו רק {{count}}",

      // Cart
      "cart.addProducts": "הוסף מוצרים כדי להתחיל",
      "cart.subtotal": "סכום ביניים",
      "cart.tax": "מס (IVA 16%)",

      // Checkout Steps
      "checkout.enterDelivery": "הזן פרטי משלוח",
      "checkout.completePurchase": "השלם את הרכישה",
      "checkout.backToCart": "חזור לעגלה",
      "checkout.whereDeliver": "לאן נשלח את המוצרים שלך?",
      "checkout.continueToPayment": "המשך לתשלום",
      "checkout.securelyComplete": "השלם את הרכישה בבטחה",
      "checkout.demoNotice":
        "זוהי הדגמה. השתמש במספר כרטיס 4242 4242 4242 4242 עם כל תאריך עתידי ו-CVV.",
      "checkout.cardholderName": "שם בעל הכרטיס",
      "checkout.cardNumber": "מספר כרטיס",
      "checkout.expiryDate": "תאריך תפוגה",
      "checkout.cvv": "CVV",
      "checkout.backToShipping": "חזור למשלוח",
      "checkout.processing": "מעבד...",
      "checkout.orderSummary": "סיכום הזמנה",
      "checkout.subtotal": "סכום ביניים",
      "checkout.taxIVA": "מס (IVA 16%)",
      "checkout.deliveryAddress": "כתובת משלוח",

      // Dashboard
      "dashboard.backToStore": "חזור לחנות",
      "dashboard.welcomeBack": "ברוך שובך",
      "dashboard.trackRecent": "עקוב אחר ההזמנות האחרונות שלך",
      "dashboard.noOrdersYet": "אין הזמנות עדיין",
      "dashboard.startShopping": "התחל לקנות",
      "dashboard.customer.title": "לוח בקרה לקוח",
      "dashboard.customer.totalOrders": "סה״כ הזמנות",
      "dashboard.customer.recentOrders": "הזמנות אחרונות",
      "dashboard.customer.orderStats": "סטטיסטיקות הזמנות",
      "dashboard.customer.pendingOrders": "הזמנות ממתינות",
      "dashboard.customer.completedOrders": "הזמנות שהושלמו",
      "dashboard.customer.filterByStatus": "סנן לפי סטטוס",
      "dashboard.customer.allStatuses": "כל הסטטוסים",
      "dashboard.customer.noOrdersFound": "לא נמצאו הזמנות",
      "dashboard.customer.viewAllOrders": "צפה בכל ההזמנות",
      "dashboard.manageOrders": "נהל הזמנות ומלאי",
      "dashboard.manageStore": "נהל את החנות שלך",
      "dashboard.overview": "סקירה כללית",
      "dashboard.totalProducts": "סה״כ מוצרים",
      "dashboard.ordersToday": "הזמנות היום",
      "dashboard.revenue": "הכנסות",
      "dashboard.manageCatalog": "נהל את קטלוג המוצרים שלך",
      "dashboard.addProduct": "הוסף מוצר",
      "dashboard.searchProducts": "חפש מוצרים...",
      "dashboard.product": "מוצר",
      "dashboard.category": "קטגוריה",
      "dashboard.price": "מחיר",
      "dashboard.stock": "מלאי",
      "dashboard.status": "סטטוס",
      "dashboard.actions": "פעולות",
      "dashboard.active": "פעיל",
      "dashboard.inactive": "לא פעיל",
      "dashboard.organizeCategories": "ארגן את קטגוריות המוצרים שלך",
      "dashboard.addCategory": "הוסף קטגוריה",
      "dashboard.productsCount": "מוצרים",
      "dashboard.revenueOverview": "סקירת הכנסות",
      "dashboard.ordersTrend": "מגמת הזמנות",
      "dashboard.salesByCategory": "מכירות לפי קטגוריה",
      "dashboard.customer": "לקוח",
      "dashboard.processOrders": "עבד הזמנות לקוחות",
      "dashboard.filterByCategory": "סנן לפי קטגוריה",
      "dashboard.allCategories": "כל הקטגוריות",
      "dashboard.noProductsFound": "לא נמצאו מוצרים",
      "dashboard.noProducts": "אין מוצרים זמינים",
      "dashboard.noCategories": "אין קטגוריות זמינות",
      "dashboard.slug": "מזהה",

      // Admin
      "admin.noCategory": "ללא קטגוריה",
      "admin.editProduct": "ערוך מוצר",
      "admin.addProduct": "הוסף מוצר",
      "admin.products": "מוצרים",
      "admin.editProductDescription": "עדכן מידע על המוצר",
      "admin.addProductDescription": "צור מוצר חדש",
      "admin.productName": "שם המוצר",
      "admin.enterProductName": "הזן שם מוצר",
      "admin.description": "תיאור",
      "admin.enterDescription": "הזן תיאור מוצר",
      "admin.price": "מחיר",
      "admin.stockQuantity": "כמות במלאי",
      "admin.category": "קטגוריה",
      "admin.categories": "קטגוריות",
      "admin.noCategories": "אין קטגוריות זמינות",
      "admin.selectCategory": "בחר קטגוריה",
      "admin.activeProduct": "מוצר פעיל",
      "admin.isActive": "פעיל",
      "admin.imageUrl": "קישור לתמונה",
      "admin.productImage": "תמונת מוצר",
      "admin.categoryImage": "תמונת קטגוריה",
      "admin.uploadImage": "העלה תמונה",
      "admin.cropImage": "חתוך תמונה",
      "admin.cropImageDescription":
        "גרור למיקום מחדש, השתמש במחוון הזום להתאמת הגודל",
      "admin.zoom": "זום",
      "admin.cropInstructions":
        "💡 גרור את התמונה למיקום מחדש והשתמש במחוון הזום להתאים את המוצר שלך",
      "admin.processing": "מעבד...",
      "admin.applyCrop": "החל חיתוך",
      "admin.dimensions": "מידות",
      "admin.originalSize": "גודל מקורי",
      "admin.optimizedSize": "גודל ממוטב",
      "admin.savings": "חיסכון",
      "admin.editCategory": "ערוך קטגוריה",
      "admin.addCategory": "הוסף קטגוריה",
      "admin.editCategoryDescription": "עדכן מידע על הקטגוריה",
      "admin.addCategoryDescription": "צור קטגוריה חדשה",
      "admin.categoryName": "שם הקטגוריה",
      "admin.enterCategoryName": "הזן שם קטגוריה",
      "admin.searchCategories": "חפש קטגוריות...",
      "admin.noSearchResults": "לא נמצאו תוצאות",
      "admin.parentCategory": "קטגוריית אב",
      "admin.noParent": "ללא אב",
      "admin.parentCategoryDescription":
        "בחר קטגוריית אב ליצירת תת-קטגוריה (מקסימום 2 רמות)",
      "admin.subcategoryOf": "תת-קטגוריה של",
      "admin.subcategory": "תת-קטגוריה",
      "admin.slug": "מזהה",
      "admin.slugDescription": "מזהה ידידותי לכתובת (אותיות קטנות, קווים בלבד)",
      "admin.confirmDelete": "אשר מחיקה",
      "admin.deleteProductConfirm":
        "האם אתה בטוח שברצונך למחוק את {{name}}? פעולה זו לא ניתנת לביטול.",
      "admin.deleteCategoryConfirm":
        "האם אתה בטוח שברצונך למחוק את {{name}}? פעולה זו לא ניתנת לביטול.",
      "admin.validation.requiredFields": "אנא מלא את כל השדות הנדרשים",
      "admin.validation.slugExists": "המזהה הזה כבר קיים",
      "admin.validation.categoryHasProducts":
        "לא ניתן למחוק קטגוריה שמכילה מוצרים",
      "admin.messages.productUpdated": "המוצר עודכן בהצלחה",
      "admin.messages.productAdded": "המוצר נוסף בהצלחה",
      "admin.messages.productDeleted": "המוצר נמחק בהצלחה",
      "admin.messages.categoryUpdated": "הקטגוריה עודכנה בהצלחה",
      "admin.messages.categoryAdded": "הקטגוריה נוספה בהצלחה",
      "admin.messages.categoryDeleted": "הקטגוריה נמחקה בהצלחה",
      "admin.fillRequiredFields": "אנא מלא את כל השדות הנדרשים",
      "admin.productUpdated": "המוצר עודכן בהצלחה",
      "admin.productCreated": "המוצר נוצר בהצלחה",
      "admin.productDeleted": "המוצר נמחק בהצלחה",

      // Discounts
      "discounts.form.name": "שם",
      "discounts.form.code": "קוד הנחה",
      "discounts.form.description": "תיאור",
      "discounts.title": "ניהול הנחות",
      "discounts.subtitle": "יצירה וניהול קודי הנחה וקידום מכירות",
      "discounts.addDiscount": "הוסף הנחה",
      "discounts.editDiscount": "ערוך הנחה",
      "discounts.createNew": "צור הנחה חדשה",
      "discounts.updateDetails": "עדכן את פרטי ההנחה למטה",
      "discounts.fillDetails": "מלא את הפרטים ליצירת הנחה חדשה",
      "discounts.table.code": "קוד",
      "discounts.table.automatic": "אוטומטי",
      "discounts.table.name": "שם",
      "discounts.table.type": "סוג",
      "discounts.table.value": "ערך",
      "discounts.table.usage": "שימוש",
      "discounts.table.status": "סטטוס",
      "discounts.table.dates": "תאריכים",
      "discounts.table.actions": "פעולות",
      "discounts.totalDiscounts": "הנחות בסך הכל",
      "discounts.usageStatistics": "סטטיסטיקות שימוש בהנחות",
      "discounts.totalUses": "שימושים כוללים",
      "discounts.totalDiscountAmount": "סכום הנחה כולל",
      "discounts.avgPerUse": "ממוצע לשימוש",
      "discounts.recentUsage": "שימוש אחרון",
      "discounts.usage.date": "תאריך",
      "discounts.usage.orderId": "מזהה הזמנה",
      "discounts.usage.userId": "מזהה משתמש",
      "discounts.usage.discountAmount": "סכום הנחה",
      "discounts.usage.guest": "אורח",
      "discounts.status.active": "פעיל",
      "discounts.status.inactive": "לא פעיל",
      "discounts.type.percentage": "אחוז",
      "discounts.type.fixedAmount": "סכום קבוע",
      "discounts.type.buyXGetY": "קנה X קח Y",
      "discounts.type.freeShipping": "משלוח חינם",
      "discounts.condition.minimumAmount": "סכום מינימלי",
      "discounts.condition.minimumQuantity": "כמות מינימלית",
      "discounts.condition.specificProducts": "מוצרים ספציפיים",
      "discounts.condition.specificCategories": "קטגוריות ספציפיות",
      "discounts.condition.firstOrder": "הזמנה ראשונה",
      "discounts.condition.noCondition": "ללא תנאי",
      "discounts.form.discountType": "סוג הנחה",
      "discounts.form.discountValue": "ערך הנחה",
      "discounts.form.conditionType": "סוג תנאי",
      "discounts.form.minimumAmount": "סכום מינימלי (MX$)",
      "discounts.form.minimumQuantity": "כמות מינימלית",
      "discounts.form.usageLimit": "מגבלת שימוש",
      "discounts.form.maxDiscountAmount": "סכום הנחה מקסימלי (MX$)",
      "discounts.form.startDate": "תאריך התחלה",
      "discounts.form.endDate": "תאריך סיום",
      "discounts.form.active": "פעיל",
      "discounts.form.priority": "עדיפות",
      "discounts.form.priorityDescription":
        "הנחות בעדיפות גבוהה יותר מוחלות ראשונות (0 = הנמוך ביותר)",
      "discounts.form.applyToSubcategories": "החל על תת-קטגוריות",
      "discounts.form.stackable": "ניתן לצבור עם הנחות אחרות",
      "discounts.form.cancel": "ביטול",
      "discounts.form.create": "יצירה",
      "discounts.form.update": "עדכון",
      "discounts.form.discount": "הנחה",
      "discounts.form.codePlaceholder": "לדוגמה, SAVE20",
      "discounts.form.unlimitedPlaceholder": "ללא הגבלה",
      "discounts.form.noLimitPlaceholder": "ללא מגבלה",
      "discounts.form.automaticDiscount": "הנחה אוטומטית",
      "discounts.form.automaticDiscountHelp":
        "הנחות אוטומטיות מוחלות על פי תנאים ללא צורך בקוד",
      "discounts.form.required": "*",
      "discounts.select.percentage": "אחוז (%)",
      "discounts.select.fixedAmount": "סכום קבוע (MX$)",
      "discounts.select.buyXGetY": "קנה X קח Y",
      "discounts.select.freeShipping": "משלוח חינם",
      "discounts.select.noCondition": "ללא תנאי",
      "discounts.select.minimumAmount": "סכום מינימלי",
      "discounts.select.minimumQuantity": "כמות מינימלית",
      "discounts.select.firstOrder": "הזמנה ראשונה בלבד",
      "discounts.form.selectProducts": "בחר מוצרים",
      "discounts.form.selectCategories": "בחר קטגוריות",
      "discounts.form.productsSelected": "מוצר(ים) נבחר(ו)",
      "discounts.form.categoriesSelected": "קטגוריה(ות) נבחרה(ו)",
      "discounts.form.searchProducts": "חפש מוצרים...",
      "discounts.form.searchCategories": "חפש קטגוריות...",
      "discounts.form.noProductsFound": "לא נמצאו מוצרים.",
      "discounts.form.noCategoriesFound": "לא נמצאו קטגוריות.",
      "discounts.form.noProductsAvailable":
        "אין מוצרים זמינים. אנא בדוק את חיבור ה-API.",
      "discounts.form.noCategoriesAvailable":
        "אין קטגוריות זמינות. אנא בדוק את חיבור ה-API.",

      // Checkout discount messages
      "checkout.discountCode": "קוד הנחה",
      "checkout.discountCodePlaceholder": "הזן קוד הנחה",
      "checkout.discountApply": "החל",
      "checkout.discountError.enterCode": "אנא הזן קוד הנחה",
      "checkout.discountError.alreadyApplied": "קוד הנחה זה כבר מוחל",
      "checkout.discountError.invalid": "קוד הנחה לא תקף",
      "checkout.discountRemove": "הסר",
      "checkout.discountAmount": "הנחה",

      // Available Discounts Display
      "discounts.availableCoupons": "קופונים זמינים",
      "discounts.automaticDiscounts": "הנחות אוטומטיות",
      "discounts.off": "הנחה",
      "discounts.freeShipping": "משלוח חינם",
      "discounts.discount": "הנחה",
      "discounts.minimumAmount": "הזמנות מעל MX${{amount}}",
      "discounts.minimumQuantity": "{{quantity}}+ פריטים נדרשים",
      "discounts.firstOrderOnly": "הזמנה ראשונה בלבד",
      "discounts.noCondition": "ללא תנאים",
      "discounts.validUntil": "תקף עד {{date}}",
      "discounts.apply": "החל",
      "discounts.copyCode": "העתק קוד",
      "discounts.applied": "הנחה הוחלה!",
      "discounts.codeCopied": "הקוד הועתק ללוח!",
      "discounts.automatic": "אוטומטי",
      "discounts.automaticApply": "מוחל אוטומטית בקופה",
      "discounts.noDiscountsAvailable": "אין הנחות זמינות כרגע",

      // Discount Display Component
      "discounts.availableOffers": "הצעות זמינות",
      "discounts.clickToViewOffers": "לחץ לצפייה בהנחות וקופונים זמינים",
      "discounts.couponCodes": "קודי קופון",

      // Cart Discount Keys
      "cart.enterCouponCode": "הזן קוד קופון",
      "cart.couponCodePlaceholder": "הזן קוד קופון",
      "cart.apply": "החל",
      "cart.applying": "מחיל...",
      "cart.appliedDiscounts": "הנחות שהוחלו",
      "discounts.use": "השתמש",
      "discounts.notEligible": "לא זכאי",

      // Price Example Keys
      "discounts.originalPrice": "מחיר מקורי",
      "discounts.yourPrice": "המחיר שלך",
      "discounts.youSave": "אתה חוסך",
      "discounts.notApplicableToSample": "נדרש מינימום MX${price} להנחה זו",

      // Cart Specific Keys
      "cart.currentTotal": 'סה"כ נוכחי',
      "cart.afterDiscount": "אחרי ההנחה",
      "discounts.included": "כלול",

      // Discount Validation Keys
      "discounts.removed": "הנחה הוסרה",
      "discounts.noLongerValid": "{{name}} כבר לא תקפה לעגלה שלך",
      "discounts.validationError": "שגיאה באימות הנחת {{name}}",

      // Discount Error Messages
      "discounts.errors.inactive": "הנחה זו אינה פעילה כרגע",
      "discounts.errors.notStarted": "הנחה זו מתחילה ב-{{date}}",
      "discounts.errors.expired": "הנחה זו פגה ב-{{date}}",
      "discounts.errors.usageLimitReached": "הנחה זו הגיעה למגבלת השימוש שלה",
      "discounts.errors.minimumAmountNotMet":
        "דרוש הזמנה מינימלית של MX${{required}} (נוכחי: MX${{current}})",
      "discounts.errors.minimumQuantityNotMet":
        "דרושים מינימום {{required}} פריטים (נוכחי: {{current}})",
      "discounts.errors.notFirstOrder": "הנחה זו תקפה רק ללקוחות חדשים",

      // Table display
      "discounts.table.productsSelected": "מוצרים: {{count}} נבחרו",
      "discounts.table.categoriesSelected": "קטגוריות: {{count}} נבחרו",
      "discounts.appliesTo.allProducts": "חל על כל המוצרים",
      "discounts.table.dateFrom": "מ:",
      "discounts.table.dateTo": "עד:",

      "admin.categoryUpdated": "הקטגוריה עודכנה בהצלחה",
      "admin.categoryCreated": "הקטגוריה נוצרה בהצלחה",
      "admin.categoryDeleted": "הקטגוריה נמחקה בהצלחה",
      "admin.product": "מוצר",
      "admin.stock": "מלאי",
      "admin.status": "סטטוס",
      "admin.actions": "פעולות",

      // Dashboard Missing Keys
      "dashboard.manageProducts": "נהל את קטלוג המוצרים שלך",
      "dashboard.admin.orders": "נהל הזמנות",
      "dashboard.admin.userUpdated": "המשתמש עודכן בהצלחה",
      "dashboard.admin.userRoleUpdated": "תפקיד המשתמש עודכן בהצלחה",
      "dashboard.admin.manageUsers": "נהל חשבונות משתמשים והרשאות",
      "dashboard.admin.role": "תפקיד",
      "dashboard.admin.cashPayment": "תשלום במזומן",
      "dashboard.admin.enabled": "מופעל",
      "dashboard.admin.disabled": "מבוטל",
      "dashboard.admin.systemUser": "משתמש מערכת",
      "dashboard.admin.customer": "לקוח",
      "dashboard.admin.roles.admin": "מנהל",
      "dashboard.admin.roles.employee": "עובד",
      "dashboard.admin.roles.client": "לקוח",
      "dashboard.manageAllOrders": "נהל את כל הזמנות הלקוחות",

      // Common Missing Keys
      "common.actions": "פעולות",
      "common.name": "שם",

      // Order Success
      "orderSuccess.confirmed": "הזמנה אושרה!",
      "orderSuccess.thankYou": "תודה על הרכישה. ההזמנה שלך בוצעה בהצלחה.",
      "orderSuccess.orderNumber": "מספר הזמנה",
      "orderSuccess.estimatedDelivery": "משלוח משוער",
      "orderSuccess.businessDays": "2-3 ימי עסקים",
      "orderSuccess.whatNext": "מה קורה הלאה?",
      "orderSuccess.orderConfirmation": "אישור הזמנה",
      "orderSuccess.emailConfirmation": "תקבל אישור במייל בקרוב",
      "orderSuccess.orderPreparation": "הכנת הזמנה",
      "orderSuccess.teamPrepare": "הצוות שלנו יכין את המוצרים הטריים שלך",
      "orderSuccess.delivery": "משלוח",
      "orderSuccess.orderDelivered": "ההזמנה שלך תימסר לכתובת שלך",
      "orderSuccess.viewOrderDetails": "צפה בפרטי ההזמנה",
      "orderSuccess.continueShopping": "המשך לקנות",
      "orderSuccess.needHelp": "צריך עזרה עם ההזמנה שלך?",
      "orderSuccess.contactSupport": "צור קשר עם התמיכה",

      // Authentication Guest
      "auth.continueGuest": "המשך כאורח",
      "auth.continueWithGoogle": "המשך עם Google",
      "auth.orEmail": "או הכנס עם אימייל",

      // Profile
      "profile.name": "שם",
      "profile.email": "אימייל",
      "profile.role": "תפקיד",
      "profile.manageAccount": "נהל את פרטי החשבון שלך",

      // Toast Messages
      "toast.loginSuccess": "התחברות הצליחה!",
      "toast.loginError": "אימייל או סיסמה שגויים",
      "toast.loginErrorGeneral": "אירעה שגיאה במהלך ההתחברות",
      "toast.passwordsNotMatch": "הסיסמאות לא תואמות",
      "toast.passwordTooShort": "הסיסמה חייבת להיות באורך של לפחות 6 תווים",
      "toast.accountCreated": "החשבון נוצר בהצלחה!",
      "toast.accountCreateFailed": "יצירת החשבון נכשלה",
      "toast.registrationError": "אירעה שגיאה במהלך ההרשמה",
      "toast.pleaseLogin": "אנא התחבר כדי להוסיף פריטים לעגלה",
      "toast.notEnoughStock": "אין מספיק מלאי זמין",
      "toast.addedToCart": "נוסף לעגלה",
      "toast.removedFromCart": "פריט הוסר מהעגלה",
      "toast.cartCleared": "העגלה רוקנה",
      "toast.failedToAddToCart": "הוספת פריט לעגלה נכשלה",
      "toast.failedToRemoveFromCart": "הסרת פריט מהעגלה נכשלה",
      "toast.failedToUpdateCart": "עדכון העגלה נכשל",
      "toast.fillRequiredFields": "אנא מלא את כל השדות הנדרשים",
      "toast.orderPlaced": "ההזמנה בוצעה בהצלחה!",
      "toast.orderPlacedCash": "ההזמנה בוצעה! התשלום יתבצע במזומן עם המשלוח.",
      "toast.paymentFailed": "התשלום נכשל. אנא נסה שוב.",
      "toast.creatingAccount": "יוצר חשבון...",

      "toast.discountsFetchFailed": "לא ניתן לטעון הנחות",
      "toast.discountUpdated": "ההנחה עודכנה",
      "toast.discountCreated": "ההנחה נוצרה",
      "toast.discountSaveFailed": "שמירת ההנחה נכשלה",
      "toast.discountDeleted": "ההנחה נמחקה",
      "toast.discountDeleteFailed": "מחיקת ההנחה נכשלה",
      "toast.discountUsageFetchFailed": "לא ניתן לטעון שימוש בהנחה",

      // Footer
      "footer.company.title": "Kosher Market",
      "footer.company.description":
        "היעד המהימן שלך למוצרים כשרים איכותיים המסופקים ישירות לפתח דלתך.",
      "footer.tagline": "מוצרי כשר פרימיום עם משלוח אישי.",
      "footer.quickLinks.title": "קישורים מהירים",
      "footer.quickLinks.home": "בית",
      "footer.quickLinks.products": "מוצרים",
      "footer.quickLinks.about": "אודות",
      "footer.quickLinks.myAccount": "החשבון שלי",
      "footer.quickLinks.account": "החשבון שלי",
      "footer.legal.title": "משפטי",
      "footer.legal.privacy": "מדיניות פרטיות",
      "footer.legal.terms": "תנאי שירות",
      "footer.legal.refund": "מדיניות החזרים",
      "footer.contact.title": "צור קשר",
      "footer.contact.phone": "טלפון",
      "footer.contact.email": "דוא״ל",
      "footer.contact.address": "כתובת",
      "footer.contact.addressLine": "קנקון, קינטנה רו, מקסיקו",
      "footer.copyright": "Kosher Market - כל הזכויות שמורות ©",
      "footer.followUs": "עקבו אחרינו",
      "footer.developedBy": "פותח על ידי",
      "footer.trust.certified": "כשר מאושר",
      "footer.trust.supervised": "השגחה רבנית",
      "footer.trust.delivery": "משלוח אמין",
      "footer.trust.windows": "חלונות אספקה ברורים",
      "footer.trust.secure": "תשלומים מאובטחים",
      "footer.trust.protected": "תשלום מוצפן",

      // Header
      "header.tagline": "מוצרי כשר פרימיום",
      "header.trust.certified": "מוצרים כשרים בלבד",
      "header.trust.delivery": "משלוח באותו היום בקנקון",
      "header.trust.secure": "תשלום מאובטח",

      // About Page
      "about.title": "אודות Kosher Market",
      "about.subtitle": "מביאים מוצרים כשרים איכותיים ישירות לפתח דלתך",
      "about.story.title": "הסיפור שלנו",
      "about.story.paragraph1":
        "Kosher Market נוסד עם משימה פשוטה: להפוך מוצרים כשרים איכותיים לנגישים לכולם בקהילה שלנו. מה שהתחיל כמבצע מקומי קטן צמח לשוק מקוון מקיף המשרת משפחות ברחבי האזור.",
      "about.story.paragraph2":
        "אנו מבינים את החשיבות של שמירה על סטנדרטים של כשרות תוך עמידה בצרכי הצרכן המודרניים. לכן אנו מבצעים קורציה קפדנית של המבחר שלנו לכלול רק מוצרים כשרים מאושרים מספקים ויצרנים מהימנים.",
      "about.story.paragraph3":
        "הצוות שלנו מסור לספק שירות לקוחות יוצא דופן, מחירים תחרותיים ואפשרויות משלוח נוחות. בין אם אתה מתכונן לשבת, חג או ארוחות יומיומיות, אנחנו כאן כדי לשרת אותך.",
      "about.ourStory.title": "הסיפור שלנו",
      "about.ourStory.text1":
        "Kosher Market נוסד עם משימה פשוה: להפוך מוצרים כשרים איכותיים לנגישים לכל בני הקהילה שלנו. מה שהתחיל כחנות משפחתית קטנה צמח להיות המקור המהימן באזור למזון כשר ומוצרי בית.",
      "about.ourStory.text2":
        "אנו מבינים את החשיבות של שמירה על חוקי הכשרות ומתגאים להציע מבחר רחב של מוצרים מוסמכים מספקים מהימנים מרחבי העולם. הצוות המסור שלנו עובד ללא לאות כדי להבטיח שכל מוצר עומד בסטנדרטים הגבוהים ביותר של הסמכת כשרות.",
      "about.ourStory.text3":
        "היום אנו משרתים מאות משפחות, מציעים משלוח נוח ושירות לקוחות יוצא דופן. אנו מחויבים לגדול עם הקהילה שלנו תוך שמירה על ערכי האיכות והשירות שמגדירים אותנו.",
      "about.mission.title": "המשימה שלנו",
      "about.mission.description":
        "לספק לקהילה שלנו גישה נוחה למוצרים כשרים באיכות הגבוהה ביותר, מועברים בזהירות ותשומת לב לפרטים. אנו שואפים להפוך את קניית מוצרים כשרים לקלה, משתלמת ואמינה עבור כל משק בית.",
      "about.mission.text":
        "לספק מוצרים כשרים אותנטיים ואיכותיים עם שירות יוצא דופן, להקל על משפחות לשמור על אורח חיים כשר. אנו שואפים ליצור חוויית קנייה חלקה המכבדת צרכים מסורתיים ומודרניים כאחד.",
      "about.whyChooseUs": "למה לבחור בנו?",
      "about.features.quality.title": "מוצרים איכותיים",
      "about.features.quality.description":
        "כל המוצרים נבחרים בקפידה ומוסמכים כשרים",
      "about.features.kosher.title": "הסמכת כשרות",
      "about.features.kosher.description":
        "הסמכה מלאה מרבנים מהימנים וארגוני כשרות",
      "about.features.delivery.title": "משלוח מהיר",
      "about.features.delivery.description":
        "שירות משלוח אמין ישירות לפתח דלתך",
      "about.features.secure.title": "קנייה מאובטחת",
      "about.features.secure.description":
        "פרטי התשלום שלך מוגנים ומאובטחים תמיד",
      "about.features.payment.title": "תשלום מאובטח",
      "about.features.payment.description":
        "עסקאות מאובטחות עם אפשרויות תשלום מרובות",
      "about.features.support.title": "תמיכת לקוחות 24/7",
      "about.features.support.description":
        "הצוות המסור שלנו כאן כדי לעזור לך בכל עת",
      "about.features.certified.title": "מאושר במלואו",
      "about.features.certified.description":
        "מאושרים בגאווה ועומדים בכל התקנות",
      "about.cta.title": "מוכן להתחיל לקנות?",
      "about.cta.description":
        "הצטרף למאות משפחות מרוצות שסומכות על Kosher Market לצרכי הכשרות שלהן",
      "about.cta.contact": "התקשר אלינו",
      "about.cta.call": "התקשר אלינו",
      "about.cta.whatsapp": "שוחח בוואטסאפ",

      // Privacy Policy Page
      "privacy.title": "מדיניות פרטיות",
      "privacy.lastUpdated": "עדכון אחרון",
      "privacy.introduction":
        "ב-Kosher Market, אנו מחויבים להגן על פרטיותך ולהבטיח את אבטחת המידע האישי שלך. מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים ומגנים על הנתונים שלך כאשר אתה משתמש באתר ובשירותים שלנו.",
      "privacy.section1.title": "מידע שאנו אוספים",
      "privacy.section1.text":
        "אנו אוספים מידע שאתה מספק לנו ישירות, כולל:\n\n• פרטים אישיים (שם, דוא״ל, מספר טלפון)\n• כתובת משלוח ומידע ליצירת קשר\n• מידע תשלום (מעובד בצורה מאובטחת דרך שותפי התשלום שלנו)\n• היסטוריית הזמנות והעדפות\n• העדפות תקשורת\n\nאנו גם אוספים אוטומטית מידע מסוים על המכשיר שלך וכיצד אתה משתמש באתר שלנו, כולל כתובת IP, סוג דפדפן ודפוסי שימוש.",
      "privacy.section2.title": "כיצד אנו משתמשים במידע שלך",
      "privacy.section2.text":
        "אנו משתמשים במידע שאנו אוספים כדי:\n\n• לעבד ולמלא את ההזמנות שלך\n• לתקשר איתך לגבי ההזמנות והחשבון שלך\n• לספק שירות לקוחות\n• לשפר את המוצרים והשירותים שלנו\n• לשלוח תקשורת שיווקית (בהסכמתך)\n• למנוע הונאה ולשפר את האבטחה\n• לעמוד בהתחייבויות משפטיות\n\nאנחנו אף פעם לא מוכרים את המידע האישי שלך לצדדים שלישיים.",
      "privacy.section3.title": "הגנת מידע ואבטחה",
      "privacy.section3.text":
        "אנו מיישמים אמצעי אבטחה תקניים בתעשייה כדי להגן על המידע האישי שלך מפני גישה לא מורשית, חשיפה או שימוש לרעה. זה כולל:\n\n• העברת נתונים מוצפנת (SSL/TLS)\n• עיבוד תשלומים מאובטח\n• ביקורות אבטחה שוטפות\n• בקרות גישה ואימות\n• הכשרת עובדים בהגנת מידע\n\nלמרות שאנו שואפים להגן על המידע שלך, אף שיטת העברה באינטרנט אינה מאובטחת ב-100%.",
      "privacy.section4.title": "עוגיות ומעקב",
      "privacy.section4.text":
        "אנו משתמשים בעוגיות וטכנולוגיות דומות כדי:\n\n• לזכור את ההעדפות וההגדרות שלך\n• להבין כיצד אתה משתמש באתר שלנו\n• לשפר את חוויית הגלישה שלך\n• לספק תוכן מותאם אישית\n\nאתה יכול לשלוט בעוגיות דרך הגדרות הדפדפן שלך. עם זאת, השבתת עוגיות עשויה להשפיע על יכולתך להשתמש בתכונות מסוימות באתר שלנו.",
      "privacy.section5.title": "הזכויות שלך",
      "privacy.section5.text":
        "יש לך זכות:\n\n• לגשת למידע האישי שלך\n• לתקן נתונים לא מדויקים\n• לבקש מחיקת הנתונים שלך\n• להתנגד לעיבוד הנתונים שלך\n• למשוך הסכמה בכל עת\n• לייצא את הנתונים שלך\n\nכדי לממש זכויות אלה, אנא צור קשר באמצעות המידע למטה.",
      "privacy.section6.title": "שינויים במדיניות זו",
      "privacy.section6.text":
        "אנו עשויים לעדכן את מדיניות הפרטיות הזו מעת לעת. נודיע לך על כל שינוי משמעותי על ידי פרסום המדיניות החדשה באתר שלנו ועדכון תאריך 'העדכון האחרון'.\n\nהשימוש המתמשך שלך בשירותים שלנו לאחר כל שינוי מעיד על הסכמתך למדיניות המעודכנת.",
      "privacy.questions": "שאלות לגבי פרטיות?",
      "privacy.contactUs":
        "אם יש לך שאלות או חששות לגבי מדיניות פרטיות זו או נוהלי הנתונים שלנו, אנא צור קשר:",
      "privacy.emailUs": "שלח לנו אימייל",
      "privacy.callUs": "התקשר אלינו",

      // Terms & Conditions
      "terms.title": "תנאים והגבלות",
      "terms.lastUpdated": "עדכון אחרון",
      "terms.introduction":
        "ברוכים הבאים ל-Kosher Market. בגישה ושימוש באתר ושירותים שלנו, אתה מסכים לעמוד בתנאים וההגבלות הבאים. אנא קרא אותם בעיון.",
      "terms.section1.title": "קבלת תנאים",
      "terms.section1.text":
        "על ידי שימוש באתר ובשירותי Kosher Market, אתה מאשר שקראת, הבנת ומסכים להיות כפוף לתנאים והגבלות אלה. אם אינך מסכים עם חלק מתנאים אלה, אנא אל תשתמש בשירותים שלנו.\n\nאנו שומרים לעצמנו את הזכות לשנות את התנאים הללו בכל עת. שימוש מתמשך בשירותים שלנו לאחר שינויים מהווה קבלה של התנאים המעודכנים.",
      "terms.section2.title": "הזמנות ותשלומים",
      "terms.section2.text":
        "• כל ההזמנות כפופות לזמינות מוצר ולקבלה על ידי Kosher Market\n• המחירים בפזו מקסיקני (MXN) וכפופים לשינוי ללא הודעה מוקדמת\n• יש להשלים את התשלום בעת ביצוע ההזמנה\n• אנו מקבלים כרטיסי אשראי עיקריים ותשלום במזומן במסירה\n• אתה מסכים לספק מידע תשלום ומשלוח מדויק\n• אישור הזמנה יישלח באימייל לאחר תשלום מוצלח",
      "terms.section3.title": "תנאי משלוח",
      "terms.section3.text":
        "• זמני משלוח הם משוערים ואינם מובטחים\n• אנו מספקים לכתובות שצוינו בתוך אזור השירות שלנו\n• מישהו חייב להיות נוכח כדי לקבל את המשלוח\n• אין אנו אחראים לעיכובים הנגרמים על ידי נסיבות מחוץ לשליטתנו\n• עלויות משלוח עשויות לחול בהתאם למיקום וערך ההזמנה\n• יש לספק הוראות משלוח מיוחדות בעת התשלום",
      "terms.section4.title": "מידע על מוצר",
      "terms.section4.text":
        "• אנו שואפים לספק תיאורים ותמונות מדויקות של מוצרים\n• כל המוצרים מאושרים כשרים על ידי רשויות מוכרות\n• אריזת מוצר בפועל עשויה להשתנות מהתמונות המוצגות\n• אנו שומרים לעצמנו את הזכות להחליף מוצרים בערך שווה או גבוה יותר אם פריטים אינם זמינים\n• אישורי כשרות מאומתים בזמן הרישום אך עשויים להשתנות",
      "terms.section5.title": "אחריות משתמש",
      "terms.section5.text":
        "• עליך להיות לפחות בן 18 להשתמש בשירותים שלנו\n• אתה אחראי לשמירה על סודיות החשבון\n• אתה מסכים לא להשתמש בשירותים שלנו למטרות בלתי חוקיות\n• עליך לספק מידע מדויק ומלא\n• אתה מסכים להודיע לנו על כל שימוש לא מורשה בחשבון\n• חשבונות מרובים מאותו משתמש אינם מורשים",
      "terms.section6.title": "הגבלת אחריות",
      "terms.section6.text":
        "Kosher Market לא יהיה אחראי עבור:\n• נזקים עקיפים, מקריים או תוצאתיים\n• אובדן רווחים או הזדמנויות עסקיות\n• עיכובים במשלוח עקב נסיבות מחוץ לשליטתנו\n• בעיות איכות מוצר המכוסות על ידי מדיניות ההחזר שלנו\n• כשלים בשירותי צד שלישי\n\nהאחריות הכוללת שלנו מוגבלת לערך ההזמנה שלך.",
      "terms.questions": "שאלות לגבי תנאים אלה?",
      "terms.contactUs":
        "אם יש לך שאלות כלשהן לגבי תנאים והגבלות אלה, אנא צור איתנו קשר:",
      "terms.emailUs": "שלח דוא״ל",
      "terms.callUs": "התקשר",

      // Refund Policy
      "refund.title": "מדיניות החזרים",
      "refund.lastUpdated": "עדכון אחרון",
      "refund.introduction":
        "ב-Kosher Market, אנו רוצים שתהיה מרוצה לחלוטין מהרכישה שלך. מדיניות החזרים זו מתארת את ההנחיות שלנו להחזרות, החזרים והחלפות.",
      "refund.section1.title": "מדיניות החזרים כללית",
      "refund.section1.text":
        "אנו מציעים החזרים או תחליפים למוצרים ש:\n• מגיעים פגומים או פגומים\n• שונים משמעותית מהתיאור\n• עברו את תאריך התפוגה שלהם בעת המסירה\n• חסרים בהזמנה שלך\n\nהחזרים מעובדים לאמצעי התשלום המקורי תוך 5-7 ימי עסקים לאחר אישור. לתשלומי מזומן, החזרים מונפקים כזיכוי חנות.",
      "refund.section2.title": "זכאות להחזרים",
      "refund.section2.text":
        "כדי להיות זכאי להחזר, עליך:\n• לפנות אלינו תוך 24 שעות מהמסירה\n• לספק תמונות של מוצרים פגומים או פגומים\n• להחזיק את המוצר באריזה המקורית שלו (במידת האפשר)\n• לספק את מספר ההזמנה ופרטי הקשר שלך\n\nהערה: פריטים מתכלים אינם ניתנים להחזרה מסיבות של היגיינה ובטיחות, אך עשויים להיות זכאים להחלפה אם הם פגומים.",
      "refund.section3.title": "לוח זמנים של תהליך החזר",
      "refund.section3.text":
        "1. צור קשר: פנה תוך 24 שעות מהמסירה\n2. סקירה: הצוות שלנו בוחן את הבקשה שלך תוך 1-2 ימי עסקים\n3. אישור: החזרים מאושרים מעובדים תוך 24 שעות\n4. החזר: הכסף חוזר לחשבון שלך תוך 5-7 ימי עסקים\n\nלבעיות דחופות, אנא התקשר אלינו ישירות ל-+52 998 550 5030.",
      "refund.section4.title": "פריטים שאינם ניתנים להחזר",
      "refund.section4.text":
        "הפריטים הבאים אינם זכאים להחזר:\n• מוצרים פתוחים או שנצרכו\n• פריטי הזמנה מיוחדת או מותאמים אישית\n• כרטיסי מתנה ופריטים קידומיים\n• מוצרים שנפגעו עקב שימוש לקוי\n• פריטים שלא דווחו תוך 24 שעות\n• מוצרים שהוחזרו ללא אישור מראש",
      "refund.section5.title": "שיטות החזר",
      "refund.section5.text":
        "החזרים מונפקים בהתאם לאמצעי התשלום המקורי שלך:\n\n• כרטיס אשראי/חיוב: החזר לאותו כרטיס תוך 5-7 ימי עסקים\n• תשלום במזומן: מונפק כזיכוי חנות לרכישות עתידיות\n• העברה בנקאית: דורש את פרטי הבנק שלך, מעובד תוך 5-7 ימי עסקים\n\nזיכוי חנות לא פג לעולם וניתן להשתמש בו לכל רכישה עתידית.",
      "refund.section6.title": "החלפות והחלפות",
      "refund.section6.text":
        "אנו מציעים החלפות חינם עבור:\n• מוצרים פגומים שהתקבלו\n• פריטים שגויים שנשלחו\n• מוצרים עם בעיות איכות\n\nהחלפות נשלחות ללא עלות נוספת. אם המוצר אינו זמין, אנו מציעים החזר מלא או זיכוי חנות. צור איתנו קשר כדי לתאם החלפה.",
      "refund.questions": "שאלות לגבי החזרים?",
      "refund.contactUs":
        "אם יש לך שאלות כלשהן לגבי מדיניות ההחזר שלנו או אם אתה צריך לבקש החזר, אנא צור איתנו קשר:",
      "refund.emailUs": "שלח דוא״ל",
      "refund.callUs": "התקשר",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: false,
    load: "languageOnly", // Use only language code (en, he) not locale (en-US, he-IL)

    react: {
      useSuspense: false,
    },

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      lookupSessionStorage: "i18nextLng",
    },

    // Enable pluralization
    nsSeparator: false,
    keySeparator: ".",
    pluralSeparator: "_",
    contextSeparator: "|",
  });

export default i18n;
